{
  "generatedAt": "2026-06-11T01:49:39.634Z",
  "source": {
    "dataDir": "device_data/site_pipeline/current/data_dat",
    "appVersion": "1.0.5",
    "patchVersion": "9",
    "patchFiles": "patch_1.zip, patch_2.zip, patch_3.zip, patch_4.zip, patch_5.zip, patch_6.zip, patch_7.zip, patch_8.zip, patch_9.zip",
    "languageFiles": "ko:0, en:2, zh-CN:2, zh-TW:2, ja:2, es:2, de:2, fr:2, pt:2, ru:2, ar:2, it:2, nl:2, tr:2, id:2, th:2, vi:2, pl:2, hi:2, sv:2, no:2, da:2, fi:2, cs:2, ro:2, hu:2, el:2, uk:2, bg:2, sk:2, hr:2, sr:2, ms:2, fil:2, he:2, fa:2, ur:2, am:2, ka:2, hy:2, jv:2, my:2, uz:2, sw:2, kk:2, ha:2, az:2, af:2, is:2, et:2, lt:2, ig:2, zu:2, xh:2, ne:2, ps:2, ku:2, ckb:2, ky:2, mn:2, tg:2, tk:2, ug:2, be:2, yo:2, bs:2, sq:2, mk:2, sl:2, lv:2, su:2, ln:2, om:2, lg:2, ny:2, sn:2, eu:2, ca:2, lb:2, gl:2, co:2, fy:2, ga:2, mt:2, gd:2, cy:2, ak:2, ceb:2, ht:2, hmn:2, ilo:2, kri:2, mg:2, lus:2, nso:2, rw:2, so:2, sm:2, tt:2, gn:2, qu:2",
    "dragonTable": "device_data/site_pipeline/current/data_dat/table_dragon.dat",
    "breedingRateTable": "device_data/site_pipeline/current/data_dat/table_breeding_rate.dat",
    "helper": "decoded/asset_pack_01/ps/project/DragonBreedingHelper.ps"
  },
  "elements": {
    "1": {
      "id": 1,
      "code": "fire",
      "name": "불",
      "type": "normal",
      "requireUserLevel": 1
    },
    "2": {
      "id": 2,
      "code": "water",
      "name": "물",
      "type": "normal",
      "requireUserLevel": 1
    },
    "3": {
      "id": 3,
      "code": "wind",
      "name": "바람",
      "type": "normal",
      "requireUserLevel": 6
    },
    "4": {
      "id": 4,
      "code": "steel",
      "name": "강철",
      "type": "normal",
      "requireUserLevel": 8
    },
    "5": {
      "id": 5,
      "code": "earth",
      "name": "땅",
      "type": "normal",
      "requireUserLevel": 10
    },
    "6": {
      "id": 6,
      "code": "lightning",
      "name": "번개",
      "type": "normal",
      "requireUserLevel": 12
    },
    "7": {
      "id": 7,
      "code": "light",
      "name": "빛",
      "type": "normal",
      "requireUserLevel": 14
    },
    "8": {
      "id": 8,
      "code": "dark",
      "name": "어둠",
      "type": "normal",
      "requireUserLevel": 16
    },
    "9": {
      "id": 9,
      "code": "dream",
      "name": "꿈",
      "type": "normal",
      "requireUserLevel": 20
    },
    "10": {
      "id": 10,
      "code": "soul",
      "name": "영혼",
      "type": "normal",
      "requireUserLevel": 24
    },
    "11": {
      "id": 11,
      "code": "dawn",
      "name": "여명",
      "type": "special",
      "requireUserLevel": 8
    },
    "12": {
      "id": 12,
      "code": "dusk",
      "name": "황혼",
      "type": "special",
      "requireUserLevel": 8
    },
    "13": {
      "id": 13,
      "code": "divine",
      "name": "신성",
      "type": "special",
      "requireUserLevel": 8
    },
    "14": {
      "id": 14,
      "code": "chaos",
      "name": "혼돈",
      "type": "special",
      "requireUserLevel": 8
    }
  },
  "tierFixedRateMax": {
    "1": 0,
    "2": 0,
    "3": 0,
    "4": 0,
    "5": 1000,
    "6": 600,
    "7": 300,
    "8": 150,
    "9": 0,
    "10": 0
  },
  "dragons": [
    {
      "id": 1001000001,
      "code": "fire",
      "name": "파이어 드래곤",
      "rarity": 3,
      "tier": 1,
      "elementIds": [
        1
      ],
      "sortedElementIds": [
        1
      ],
      "elementNames": [
        "불"
      ],
      "elementCodes": [
        "fire"
      ],
      "elementCount": 1,
      "stats": {
        "hp": 497,
        "atk": 917,
        "def": 247,
        "mag": 837,
        "mr": 167,
        "spd": 337,
        "sum": 3002
      },
      "abilityId": 14,
      "abilityName": "냉기저항",
      "baseMoveId": 101010,
      "baseMoveName": "불의 발톱",
      "ultMoveId": 101030,
      "ultMoveName": "불의 심판",
      "breedingSeconds": 450,
      "hatchingSeconds": 450,
      "buyable": true,
      "buyItems": "6002010001;1000",
      "canBreedAsParent": true,
      "requireUserLevel": 1,
      "requireUserLevelByElement": 1,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000001,
          1001000001
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 매우 붉고 뜨겁다.",
        "type": "불 드래곤",
        "feed": "닭다리",
        "weight": "250~300kg",
        "size": "3.2~3.5m",
        "obtain": "붉은 불길이 타오르는 점박이 무늬의 알이다."
      }
    },
    {
      "id": 1001000002,
      "code": "siamesedragon",
      "name": "샴 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        1,
        4
      ],
      "sortedElementIds": [
        1,
        4
      ],
      "elementNames": [
        "불",
        "강철"
      ],
      "elementCodes": [
        "fire",
        "steel"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1003,
        "atk": 1053,
        "def": 423,
        "mag": 673,
        "mr": 423,
        "spd": 423,
        "sum": 3998
      },
      "abilityId": 33,
      "abilityName": "인내",
      "baseMoveId": 101010,
      "baseMoveName": "불의 발톱",
      "ultMoveId": 101030,
      "ultMoveName": "불의 심판",
      "breedingSeconds": 7200,
      "hatchingSeconds": 7200,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 8,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000002,
          1001000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 확실한 경계선이 있다.",
        "type": "쌍두 드래곤",
        "feed": "불당근",
        "weight": "90~120kg",
        "size": "1.7~2.4m",
        "obtain": "두 자아가 나누어져 있는 신비로운 알이다."
      }
    },
    {
      "id": 1001000003,
      "code": "ignis",
      "name": "이그니스",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        1,
        7
      ],
      "sortedElementIds": [
        1,
        7
      ],
      "elementNames": [
        "불",
        "빛"
      ],
      "elementCodes": [
        "fire",
        "light"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1153,
        "atk": 1733,
        "def": 323,
        "mag": 1,
        "mr": 323,
        "spd": 983,
        "sum": 4516
      },
      "abilityId": 44,
      "abilityName": "화염 증폭",
      "baseMoveId": 101010,
      "baseMoveName": "불의 발톱",
      "ultMoveId": 101030,
      "ultMoveName": "불의 심판",
      "breedingSeconds": 18900,
      "hatchingSeconds": 18900,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000003,
          1001000003
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 날카로운 지느러미가 있다.",
        "type": "불 드래곤",
        "feed": "메뚜기",
        "weight": "230~270kg",
        "size": "2.8~3.2m",
        "obtain": "날카로운 지느러미가 돋아나 있는 알이다."
      }
    },
    {
      "id": 1001000004,
      "code": "firetail",
      "name": "불나래",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        1,
        3
      ],
      "sortedElementIds": [
        1,
        3
      ],
      "elementNames": [
        "불",
        "바람"
      ],
      "elementCodes": [
        "fire",
        "wind"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1115,
        "atk": 1335,
        "def": 365,
        "mag": 955,
        "mr": 365,
        "spd": 365,
        "sum": 4500
      },
      "abilityId": 16,
      "abilityName": "화염투혼",
      "baseMoveId": 101010,
      "baseMoveName": "불의 발톱",
      "ultMoveId": 101030,
      "ultMoveName": "불의 심판",
      "breedingSeconds": 7650,
      "hatchingSeconds": 7650,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 6,
      "requireUserLevelByElement": 6,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000004,
          1001000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 털은 매우 부드럽다.",
        "type": "구미호 드래곤",
        "feed": "불당근",
        "weight": "120~150kg",
        "size": "2.4~2.8m",
        "obtain": "중앙을 감싸는 부드럽고 포근한 털이 특징이다."
      }
    },
    {
      "id": 1001000005,
      "code": "jujak",
      "name": "주작",
      "rarity": 4,
      "tier": 7,
      "elementIds": [
        1,
        3,
        7
      ],
      "sortedElementIds": [
        1,
        3,
        7
      ],
      "elementNames": [
        "불",
        "바람",
        "빛"
      ],
      "elementCodes": [
        "fire",
        "wind",
        "light"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 767,
        "atk": 667,
        "def": 717,
        "mag": 1417,
        "mr": 1187,
        "spd": 1247,
        "sum": 6002
      },
      "abilityId": 29,
      "abilityName": "필사의 의지",
      "baseMoveId": 101020,
      "baseMoveName": "불의 파동",
      "ultMoveId": 101103,
      "ultMoveName": "버닝쇼크",
      "breedingSeconds": 54000,
      "hatchingSeconds": 54000,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 19,
        "fixedProportion": 150,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000005,
          1001000005
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 남쪽에서 기운이 강하게 느껴진다.",
        "type": "사신 드래곤",
        "feed": "칠면조 구이",
        "weight": "200~250kg",
        "size": "2.8~3.2m",
        "obtain": "남쪽의 강한 기운이 느껴지며\\n영원히 타오르는 불꽃의 알이다."
      }
    },
    {
      "id": 1001000006,
      "code": "magnello",
      "name": "마그넬로",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        1,
        2
      ],
      "sortedElementIds": [
        1,
        2
      ],
      "elementNames": [
        "불",
        "물"
      ],
      "elementCodes": [
        "fire",
        "water"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 610,
        "atk": 840,
        "def": 410,
        "mag": 840,
        "mr": 410,
        "spd": 890,
        "sum": 4000
      },
      "abilityId": 30,
      "abilityName": "포효",
      "baseMoveId": 101010,
      "baseMoveName": "불의 발톱",
      "ultMoveId": 101030,
      "ultMoveName": "불의 심판",
      "breedingSeconds": 8100,
      "hatchingSeconds": 8100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 1,
      "requireUserLevelByElement": 1,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000006,
          1001000006
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 산호는 자라난다.",
        "type": "산호 드래곤",
        "feed": "불멜론",
        "weight": "90~110kg",
        "size": "1.7~2.2m",
        "obtain": "표면의 산호가 부화까지 자라난다."
      }
    },
    {
      "id": 1001000007,
      "code": "lava",
      "name": "라바 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        1,
        5
      ],
      "sortedElementIds": [
        1,
        5
      ],
      "elementNames": [
        "불",
        "땅"
      ],
      "elementCodes": [
        "fire",
        "earth"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 402,
        "atk": 902,
        "def": 272,
        "mag": 822,
        "mr": 572,
        "spd": 1032,
        "sum": 4002
      },
      "abilityId": 6,
      "abilityName": "광분",
      "baseMoveId": 101010,
      "baseMoveName": "불의 발톱",
      "ultMoveId": 101030,
      "ultMoveName": "불의 심판",
      "breedingSeconds": 9000,
      "hatchingSeconds": 9000,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000007,
          1001000007
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 표면엔 용암이 굳어 있다.",
        "type": "용암 드래곤",
        "feed": "불당근",
        "weight": "380~400kg",
        "size": "2.9~3.5m",
        "obtain": "양옆에 뿔 모양 용암이 붙어 있으며\\n표면은 열을 차단해 차갑다."
      }
    },
    {
      "id": 1001000008,
      "code": "taros",
      "name": "타로스",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        1,
        5
      ],
      "sortedElementIds": [
        1,
        5
      ],
      "elementNames": [
        "불",
        "땅"
      ],
      "elementCodes": [
        "fire",
        "earth"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 825,
        "atk": 1025,
        "def": 505,
        "mag": 1155,
        "mr": 505,
        "spd": 485,
        "sum": 4500
      },
      "abilityId": 17,
      "abilityName": "내성",
      "baseMoveId": 101020,
      "baseMoveName": "불의 파동",
      "ultMoveId": 101040,
      "ultMoveName": "불의 권능",
      "breedingSeconds": 32850,
      "hatchingSeconds": 32850,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000008,
          1001000008
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 혹이 나 있다.",
        "type": "용암 드래곤",
        "feed": "닭다리",
        "weight": "280~300kg",
        "size": "2.0~3.5m",
        "obtain": "표면에 붉은 혹이 나 있으며 용암을 흡수하는 알이다."
      }
    },
    {
      "id": 1001000009,
      "code": "hell",
      "name": "헬 드래곤",
      "rarity": 4,
      "tier": 7,
      "elementIds": [
        1,
        8,
        4
      ],
      "sortedElementIds": [
        1,
        4,
        8
      ],
      "elementNames": [
        "불",
        "어둠",
        "강철"
      ],
      "elementCodes": [
        "fire",
        "dark",
        "steel"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 852,
        "atk": 832,
        "def": 1102,
        "mag": 1502,
        "mr": 1102,
        "spd": 612,
        "sum": 6002
      },
      "abilityId": 16,
      "abilityName": "화염투혼",
      "baseMoveId": 101020,
      "baseMoveName": "불의 파동",
      "ultMoveId": 101104,
      "ultMoveName": "헬브레스",
      "breedingSeconds": 55800,
      "hatchingSeconds": 55800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 19,
        "fixedProportion": 150,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000009,
          1001000009
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 오래 쳐다보지 않는 것이 좋다.",
        "type": "악마 드래곤",
        "feed": "닭",
        "weight": "270~300kg",
        "size": "3.2~3.9m",
        "obtain": "알 위에 악마의 뿔과 감시하는 듯한 눈이 달려 있다."
      }
    },
    {
      "id": 1001000010,
      "code": "popomo",
      "name": "포포모",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        1,
        9
      ],
      "sortedElementIds": [
        1,
        9
      ],
      "elementNames": [
        "불",
        "꿈"
      ],
      "elementCodes": [
        "fire",
        "dream"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 785,
        "atk": 1165,
        "def": 585,
        "mag": 1165,
        "mr": 585,
        "spd": 1215,
        "sum": 5500
      },
      "abilityId": 4,
      "abilityName": "강심장",
      "baseMoveId": 101010,
      "baseMoveName": "불의 발톱",
      "ultMoveId": 101030,
      "ultMoveName": "불의 심판",
      "breedingSeconds": 24300,
      "hatchingSeconds": 24300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000010,
          1001000010
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 벚나무 주변에서 발견된다.",
        "type": "요정 드래곤",
        "feed": "마술 꽃잎",
        "weight": "50~70kg",
        "size": "1.5~1.8m",
        "obtain": "주로 봄에 벚나무 주변에서 발견되는 알이다."
      }
    },
    {
      "id": 1001000012,
      "code": "afrit",
      "name": "아프리트",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        1,
        9
      ],
      "sortedElementIds": [
        1,
        9
      ],
      "elementNames": [
        "불",
        "꿈"
      ],
      "elementCodes": [
        "fire",
        "dream"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 665,
        "atk": 715,
        "def": 545,
        "mag": 595,
        "mr": 515,
        "spd": 1465,
        "sum": 4500
      },
      "abilityId": 21,
      "abilityName": "불쏘시개",
      "baseMoveId": 101010,
      "baseMoveName": "불의 발톱",
      "ultMoveId": 101030,
      "ultMoveName": "불의 심판",
      "breedingSeconds": 22500,
      "hatchingSeconds": 22500,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000012,
          1001000012
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 봉인되어 있다.",
        "type": "불꽃 드래곤",
        "feed": "닭",
        "weight": "210~260kg",
        "size": "3~3.5m",
        "obtain": "불꽃의 기운이 봉인되어 있는 알이다."
      }
    },
    {
      "id": 1001000013,
      "code": "patroa",
      "name": "패트로아",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        1,
        10
      ],
      "sortedElementIds": [
        1,
        10
      ],
      "elementNames": [
        "불",
        "영혼"
      ],
      "elementCodes": [
        "fire",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 825,
        "atk": 1025,
        "def": 505,
        "mag": 1155,
        "mr": 505,
        "spd": 485,
        "sum": 4500
      },
      "abilityId": 1,
      "abilityName": "일출",
      "baseMoveId": 101020,
      "baseMoveName": "불의 파동",
      "ultMoveId": 101040,
      "ultMoveName": "불의 권능",
      "breedingSeconds": 26550,
      "hatchingSeconds": 26550,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000013,
          1001000013
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 에메랄드 스네이크가 감싸고 있다.",
        "type": "화염 드래곤",
        "feed": "불당근",
        "weight": "320~380kg",
        "size": "3.8~4.1m",
        "obtain": "에메랄드 스네이크가 타오르는 열기를 견디며\\n알을 감싸 보호한다."
      }
    },
    {
      "id": 1001000014,
      "code": "dragonslayer",
      "name": "드래곤 슬레이어",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        1,
        10,
        8
      ],
      "sortedElementIds": [
        1,
        8,
        10
      ],
      "elementNames": [
        "불",
        "영혼",
        "어둠"
      ],
      "elementCodes": [
        "fire",
        "soul",
        "dark"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 963,
        "atk": 1363,
        "def": 693,
        "mag": 1023,
        "mr": 1763,
        "spd": 693,
        "sum": 6498
      },
      "abilityId": 53,
      "abilityName": "충동",
      "baseMoveId": 101010,
      "baseMoveName": "불의 발톱",
      "ultMoveId": 101105,
      "ultMoveName": "폭주",
      "breedingSeconds": 61200,
      "hatchingSeconds": 61200,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000014,
          1001000014
        ]
      },
      "drop": "raid",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 모두에게서 잊혔다.",
        "type": "고대 드래곤",
        "feed": "퍼플튤립",
        "weight": "330~360kg",
        "size": "5.5~5.8m",
        "obtain": "참혹한 전쟁을 치르고 홀로 남겨진 듯\\n고독함이 느껴지는 알이다."
      }
    },
    {
      "id": 1001000015,
      "code": "phoenix",
      "name": "피닉스 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        1,
        7
      ],
      "sortedElementIds": [
        1,
        7
      ],
      "elementNames": [
        "불",
        "빛"
      ],
      "elementCodes": [
        "fire",
        "light"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 512,
        "atk": 612,
        "def": 512,
        "mag": 872,
        "mr": 622,
        "spd": 872,
        "sum": 4002
      },
      "abilityId": 44,
      "abilityName": "화염 증폭",
      "baseMoveId": 101020,
      "baseMoveName": "불의 파동",
      "ultMoveId": 101040,
      "ultMoveName": "불의 권능",
      "breedingSeconds": 7500,
      "hatchingSeconds": 7500,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000015,
          1001000015
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 불타오르고 있다.",
        "type": "불사조 드래곤",
        "feed": "칠면조 구이",
        "weight": "80~90kg",
        "size": "2.7~3.5m",
        "obtain": "전체가 타오르는 알이며 작은 불씨만 있어도\\n다시 불길이 치솟는다."
      }
    },
    {
      "id": 1001000016,
      "code": "enturas",
      "name": "엔투라스",
      "rarity": 4,
      "tier": 7,
      "elementIds": [
        1,
        9,
        5
      ],
      "sortedElementIds": [
        1,
        5,
        9
      ],
      "elementNames": [
        "불",
        "꿈",
        "땅"
      ],
      "elementCodes": [
        "fire",
        "dream",
        "earth"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 858,
        "atk": 1528,
        "def": 698,
        "mag": 1358,
        "mr": 698,
        "spd": 858,
        "sum": 5998
      },
      "abilityId": 21,
      "abilityName": "불쏘시개",
      "baseMoveId": 101010,
      "baseMoveName": "불의 발톱",
      "ultMoveId": 101107,
      "ultMoveName": "코로나 폭발",
      "breedingSeconds": 56200,
      "hatchingSeconds": 56200,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1001000016,
          1001000016
        ]
      },
      "drop": "sell",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 소멸을 불러오는 불꽃이 피어오른다.",
        "type": "파수꾼 드래곤",
        "feed": "칠면조 구이",
        "weight": "150~180kg",
        "size": "3.5~3.8m",
        "obtain": "뿔 사이에서 소멸의 불꽃이\\n아주 작게 일렁이며 피어오르는 알이다."
      }
    },
    {
      "id": 1002000001,
      "code": "aquadragon",
      "name": "아쿠아 드래곤",
      "rarity": 3,
      "tier": 1,
      "elementIds": [
        2
      ],
      "sortedElementIds": [
        2
      ],
      "elementNames": [
        "물"
      ],
      "elementCodes": [
        "water"
      ],
      "elementCount": 1,
      "stats": {
        "hp": 513,
        "atk": 513,
        "def": 353,
        "mag": 513,
        "mr": 353,
        "spd": 753,
        "sum": 2998
      },
      "abilityId": 27,
      "abilityName": "태풍",
      "baseMoveId": 102010,
      "baseMoveName": "물의 발톱",
      "ultMoveId": 102030,
      "ultMoveName": "물의 심판",
      "breedingSeconds": 450,
      "hatchingSeconds": 450,
      "buyable": true,
      "buyItems": "6002010001;1000",
      "canBreedAsParent": true,
      "requireUserLevel": 1,
      "requireUserLevelByElement": 1,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1002000001,
          1002000001
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 물처럼 시원하다.",
        "type": "물 드래곤",
        "feed": "피레미오",
        "weight": "200~230kg",
        "size": "3.2~3.6m",
        "obtain": "새파란 물빛과 매끈한 촉감을 지닌 알이다."
      }
    },
    {
      "id": 1002000002,
      "code": "frog",
      "name": "프로그 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        2,
        10
      ],
      "sortedElementIds": [
        2,
        10
      ],
      "elementNames": [
        "물",
        "영혼"
      ],
      "elementCodes": [
        "water",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1053,
        "atk": 893,
        "def": 893,
        "mag": 553,
        "mr": 553,
        "spd": 53,
        "sum": 3998
      },
      "abilityId": 28,
      "abilityName": "봄바람",
      "baseMoveId": 102010,
      "baseMoveName": "물의 발톱",
      "ultMoveId": 102030,
      "ultMoveName": "물의 심판",
      "breedingSeconds": 25650,
      "hatchingSeconds": 25650,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1002000002,
          1002000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 매끈하지만 거친 털을 가지고 있다.",
        "type": "물 드래곤",
        "feed": "귀뚜라미, 밀웜",
        "weight": "60~75kg",
        "size": "1.7~2m",
        "obtain": "연꽃처럼 연잎 위에서 물 위를 둥둥 떠다니는\\n신비로운 알이다."
      }
    },
    {
      "id": 1002000003,
      "code": "sharkgon",
      "name": "샤크곤",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        2,
        4
      ],
      "sortedElementIds": [
        2,
        4
      ],
      "elementNames": [
        "물",
        "강철"
      ],
      "elementCodes": [
        "water",
        "steel"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1278,
        "atk": 1148,
        "def": 358,
        "mag": 608,
        "mr": 528,
        "spd": 578,
        "sum": 4498
      },
      "abilityId": 27,
      "abilityName": "태풍",
      "baseMoveId": 102010,
      "baseMoveName": "물의 발톱",
      "ultMoveId": 102030,
      "ultMoveName": "물의 심판",
      "breedingSeconds": 27900,
      "hatchingSeconds": 27900,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 8,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1002000003,
          1002000003
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 무척 상어를 닮았다.",
        "type": "상어 드래곤",
        "feed": "피레미오",
        "weight": "460~500kg",
        "size": "3.8~4.1m",
        "obtain": "날카로운 지느러미가 돋아나 있는 알이다."
      }
    },
    {
      "id": 1002000004,
      "code": "swamp",
      "name": "스왐프 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        2,
        5
      ],
      "sortedElementIds": [
        2,
        5
      ],
      "elementNames": [
        "물",
        "땅"
      ],
      "elementCodes": [
        "water",
        "earth"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1200,
        "atk": 360,
        "def": 860,
        "mag": 360,
        "mr": 860,
        "spd": 360,
        "sum": 4000
      },
      "abilityId": 5,
      "abilityName": "속박",
      "baseMoveId": 102020,
      "baseMoveName": "물의 파동",
      "ultMoveId": 102040,
      "ultMoveName": "물의 권능",
      "breedingSeconds": 9900,
      "hatchingSeconds": 9900,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1002000004,
          1002000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 자연의 일부와 닮아있다.",
        "type": "늪지 드래곤",
        "feed": "메기슨",
        "weight": "280~350kg",
        "size": "2.5~2.9m",
        "obtain": "잎과 열매, 중앙의 단단한 갑주가 조화를 이루는 알이다."
      }
    },
    {
      "id": 1002000005,
      "code": "rupia",
      "name": "루피아",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        2,
        9
      ],
      "sortedElementIds": [
        2,
        9
      ],
      "elementNames": [
        "물",
        "꿈"
      ],
      "elementCodes": [
        "water",
        "dream"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 667,
        "atk": 1167,
        "def": 667,
        "mag": 1167,
        "mr": 667,
        "spd": 167,
        "sum": 4502
      },
      "abilityId": 39,
      "abilityName": "흡수",
      "baseMoveId": 102020,
      "baseMoveName": "물의 파동",
      "ultMoveId": 102040,
      "ultMoveName": "물의 권능",
      "breedingSeconds": 26550,
      "hatchingSeconds": 26550,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1002000005,
          1002000005
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 바다 생물의 보호를 받는다.",
        "type": "바다 드래곤",
        "feed": "퍼플튤립",
        "weight": "40~60kg",
        "size": "1.6~1.9m",
        "obtain": "심해의 어둠 속에서 푸른 빛을 내뿜는 신비로운 알이다."
      }
    },
    {
      "id": 1002000006,
      "code": "poisonriver",
      "name": "포이즌 리버",
      "rarity": 4,
      "tier": 6,
      "elementIds": [
        2,
        8
      ],
      "sortedElementIds": [
        2,
        8
      ],
      "elementNames": [
        "물",
        "어둠"
      ],
      "elementCodes": [
        "water",
        "dark"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 997,
        "atk": 417,
        "def": 737,
        "mag": 1087,
        "mr": 1497,
        "spd": 767,
        "sum": 5502
      },
      "abilityId": 47,
      "abilityName": "접촉 금지",
      "baseMoveId": 102020,
      "baseMoveName": "물의 파동",
      "ultMoveId": 102040,
      "ultMoveName": "물의 권능",
      "breedingSeconds": 26100,
      "hatchingSeconds": 26100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 25,
        "fixedProportion": 300,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1002000006,
          1002000006
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 촉수가 달려있다.",
        "type": "독 드래곤",
        "feed": "메기슨",
        "weight": "200~250kg",
        "size": "1.8~2.0m",
        "obtain": "네 갈래의 촉수가 달린 알이며 표면에서\\n적은 양의 독이 방출된다."
      }
    },
    {
      "id": 1002000007,
      "code": "frost",
      "name": "빙하고룡",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        2,
        5,
        7
      ],
      "sortedElementIds": [
        2,
        5,
        7
      ],
      "elementNames": [
        "물",
        "땅",
        "빛"
      ],
      "elementCodes": [
        "water",
        "earth",
        "light"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 1092,
        "atk": 1062,
        "def": 1092,
        "mag": 1232,
        "mr": 1142,
        "spd": 882,
        "sum": 6502
      },
      "abilityId": 7,
      "abilityName": "심해의 힘",
      "baseMoveId": 102020,
      "baseMoveName": "물의 파동",
      "ultMoveId": 102103,
      "ultMoveName": "프로스트 웨이브",
      "breedingSeconds": 59400,
      "hatchingSeconds": 59400,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1002000007,
          1002000007
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 매우 차갑다.",
        "type": "빙하 드래곤",
        "feed": "피레미오",
        "weight": "400~450kg",
        "size": "3.5~3.8m",
        "obtain": "날카로운 얼음과 냉기로 뒤덮여 있어\\n자연 냉장고 역할을 하는 알이다."
      }
    },
    {
      "id": 1002000008,
      "code": "hyeonmu",
      "name": "현무",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        2,
        4
      ],
      "sortedElementIds": [
        2,
        4
      ],
      "elementNames": [
        "물",
        "강철"
      ],
      "elementCodes": [
        "water",
        "steel"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 635,
        "atk": 1135,
        "def": 805,
        "mag": 475,
        "mr": 475,
        "spd": 975,
        "sum": 4500
      },
      "abilityId": 38,
      "abilityName": "소나기",
      "baseMoveId": 102010,
      "baseMoveName": "물의 발톱",
      "ultMoveId": 102030,
      "ultMoveName": "물의 심판",
      "breedingSeconds": 22500,
      "hatchingSeconds": 22500,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 8,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1002000008,
          1002000008
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 음과 양의 기운이 모두 느껴진다.",
        "type": "사신 드래곤",
        "feed": "메기슨",
        "weight": "450~500kg",
        "size": "2.3~2.8m",
        "obtain": "음과 양, 두 가지 상반된 기운이 동시에 느껴지는 알이다."
      }
    },
    {
      "id": 1002000009,
      "code": "tiamat",
      "name": "티아매트",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        2,
        8,
        9
      ],
      "sortedElementIds": [
        2,
        8,
        9
      ],
      "elementNames": [
        "물",
        "어둠",
        "꿈"
      ],
      "elementCodes": [
        "water",
        "dark",
        "dream"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 1000,
        "atk": 1500,
        "def": 1000,
        "mag": 1500,
        "mr": 1000,
        "spd": 500,
        "sum": 6500
      },
      "abilityId": 54,
      "abilityName": "점막",
      "baseMoveId": 102020,
      "baseMoveName": "물의 파동",
      "ultMoveId": 102104,
      "ultMoveName": "페르시온의 힘",
      "breedingSeconds": 60300,
      "hatchingSeconds": 60300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1002000009,
          1002000009
        ]
      },
      "drop": "raid",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 마음과 몸이 병들었다.",
        "type": "삼두 드래곤",
        "feed": "페르시온 조각",
        "weight": "330~360kg",
        "size": "4.5~5.0m",
        "obtain": "주변에 있는 페르시온 결정의 기운을\\n끊임없이 흡수하는 알이다."
      }
    },
    {
      "id": 1002000010,
      "code": "paruparu",
      "name": "파루파루",
      "rarity": 5,
      "tier": 8,
      "elementIds": [
        2,
        7,
        9
      ],
      "sortedElementIds": [
        2,
        7,
        9
      ],
      "elementNames": [
        "물",
        "빛",
        "꿈"
      ],
      "elementCodes": [
        "water",
        "light",
        "dream"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 903,
        "atk": 1273,
        "def": 1153,
        "mag": 733,
        "mr": 983,
        "spd": 1203,
        "sum": 6248
      },
      "abilityId": 30,
      "abilityName": "포효",
      "baseMoveId": 102010,
      "baseMoveName": "물의 발톱",
      "ultMoveId": 102105,
      "ultMoveName": "기적의 격류",
      "breedingSeconds": 60300,
      "hatchingSeconds": 60300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 13,
        "fixedProportion": 75,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1002000010,
          1002000010
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 내부에서 따뜻한 기운이 흘러나온다.",
        "type": "동물 드래곤",
        "feed": "피레미오",
        "weight": "90~110kg",
        "size": "2.5~2.8m",
        "obtain": "내부에서부터 따뜻한 기운이 흘러나오는 알이다."
      }
    },
    {
      "id": 1003000001,
      "code": "wind",
      "name": "윈드 드래곤",
      "rarity": 3,
      "tier": 1,
      "elementIds": [
        3
      ],
      "sortedElementIds": [
        3
      ],
      "elementNames": [
        "바람"
      ],
      "elementCodes": [
        "wind"
      ],
      "elementCount": 1,
      "stats": {
        "hp": 453,
        "atk": 503,
        "def": 423,
        "mag": 503,
        "mr": 423,
        "spd": 693,
        "sum": 2998
      },
      "abilityId": 31,
      "abilityName": "유연한 몸",
      "baseMoveId": 103010,
      "baseMoveName": "바람의 발톱",
      "ultMoveId": 103030,
      "ultMoveName": "바람의 심판",
      "breedingSeconds": 600,
      "hatchingSeconds": 600,
      "buyable": true,
      "buyItems": "6002010001;5000",
      "canBreedAsParent": true,
      "requireUserLevel": 6,
      "requireUserLevelByElement": 6,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000001,
          1003000001
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 바람에 흔들리려 한다.",
        "type": "바람 드래곤",
        "feed": "유그드라실",
        "weight": "70~110kg",
        "size": "2.1~2.8m",
        "obtain": "푸른색과 녹색이 어우러진 표면에\\n점무늬가 박혀 있는 가벼운 알이다."
      }
    },
    {
      "id": 1003000002,
      "code": "zephyros",
      "name": "제피로스",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        3,
        4
      ],
      "sortedElementIds": [
        3,
        4
      ],
      "elementNames": [
        "바람",
        "강철"
      ],
      "elementCodes": [
        "wind",
        "steel"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 917,
        "atk": 1087,
        "def": 417,
        "mag": 917,
        "mr": 417,
        "spd": 747,
        "sum": 4502
      },
      "abilityId": 19,
      "abilityName": "명사수",
      "baseMoveId": 103010,
      "baseMoveName": "바람의 발톱",
      "ultMoveId": 103030,
      "ultMoveName": "바람의 심판",
      "breedingSeconds": 15300,
      "hatchingSeconds": 15300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 8,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000002,
          1003000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 창공을 날 준비를 한다.",
        "type": "바람 드래곤",
        "feed": "회오리 꽃",
        "weight": "160~180kg",
        "size": "2.6~3.1m",
        "obtain": "부화 전부터 날기 위해 꿈틀대는\\n생명력이 넘치는 알이다."
      }
    },
    {
      "id": 1003000003,
      "code": "typhoondragon",
      "name": "타이푼 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        3,
        2
      ],
      "sortedElementIds": [
        2,
        3
      ],
      "elementNames": [
        "바람",
        "물"
      ],
      "elementCodes": [
        "wind",
        "water"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 792,
        "atk": 1022,
        "def": 962,
        "mag": 462,
        "mr": 622,
        "spd": 142,
        "sum": 4002
      },
      "abilityId": 9,
      "abilityName": "절대기류",
      "baseMoveId": 103010,
      "baseMoveName": "바람의 발톱",
      "ultMoveId": 103030,
      "ultMoveName": "바람의 심판",
      "breedingSeconds": 9000,
      "hatchingSeconds": 9000,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 6,
      "requireUserLevelByElement": 6,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000003,
          1003000003
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 부드러운 갈기를 가지고 있다.",
        "type": "태풍 드래곤",
        "feed": "회오리 꽃",
        "weight": "480~500kg",
        "size": "3.5~4.0m",
        "obtain": "부드러운 갈기와 작은 돌풍이 지닌 알이다."
      }
    },
    {
      "id": 1003000004,
      "code": "liberte",
      "name": "리베티",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        3,
        7
      ],
      "sortedElementIds": [
        3,
        7
      ],
      "elementNames": [
        "바람",
        "빛"
      ],
      "elementCodes": [
        "wind",
        "light"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 587,
        "atk": 417,
        "def": 667,
        "mag": 1247,
        "mr": 667,
        "spd": 917,
        "sum": 4502
      },
      "abilityId": 50,
      "abilityName": "강인한 의지",
      "baseMoveId": 103020,
      "baseMoveName": "바람의 파동",
      "ultMoveId": 103040,
      "ultMoveName": "바람의 권능",
      "breedingSeconds": 25650,
      "hatchingSeconds": 25650,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000004,
          1003000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 편지를 가지고 있다.",
        "type": "우체부 드래곤",
        "feed": "마술 꽃잎",
        "weight": "195~220kg",
        "size": "2.5~2.8m",
        "obtain": "모자를 쓰고 있으며 주변에 전할 편지를 품고 있다."
      }
    },
    {
      "id": 1003000005,
      "code": "pinkbell",
      "name": "핑크벨",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        3,
        10
      ],
      "sortedElementIds": [
        3,
        10
      ],
      "elementNames": [
        "바람",
        "영혼"
      ],
      "elementCodes": [
        "wind",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 417,
        "atk": 537,
        "def": 837,
        "mag": 697,
        "mr": 667,
        "spd": 1347,
        "sum": 4502
      },
      "abilityId": 28,
      "abilityName": "봄바람",
      "baseMoveId": 103020,
      "baseMoveName": "바람의 파동",
      "ultMoveId": 103040,
      "ultMoveName": "바람의 권능",
      "breedingSeconds": 27000,
      "hatchingSeconds": 27000,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000005,
          1003000005
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 아름답고 귀엽다.",
        "type": "요정 드래곤",
        "feed": "회오리 꽃",
        "weight": "90~100kg",
        "size": "1.5~1.8m",
        "obtain": "알에 돋아난 더듬이가 화려한 존재감을 드러낸다."
      }
    },
    {
      "id": 1003000006,
      "code": "blue",
      "name": "청룡",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        3,
        6
      ],
      "sortedElementIds": [
        3,
        6
      ],
      "elementNames": [
        "바람",
        "번개"
      ],
      "elementCodes": [
        "wind",
        "lightning"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 955,
        "atk": 1195,
        "def": 1125,
        "mag": 625,
        "mr": 795,
        "spd": 305,
        "sum": 5000
      },
      "abilityId": 15,
      "abilityName": "여유로움",
      "baseMoveId": 103010,
      "baseMoveName": "바람의 발톱",
      "ultMoveId": 103030,
      "ultMoveName": "바람의 심판",
      "breedingSeconds": 28800,
      "hatchingSeconds": 28800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 12,
      "breeding": {
        "portion": 31,
        "fixedProportion": 500,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000006,
          1003000006
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 뿔이 나 있고, 뱃가죽이 있다.",
        "type": "사신 드래곤",
        "feed": "유그드라실",
        "weight": "300~320kg",
        "size": "3.8~4.2m",
        "obtain": "노란 뿔과 초록 갈기, 푸른 비늘이 돋아나 있는\\n기품 있는 알이다."
      }
    },
    {
      "id": 1003000008,
      "code": "sixleghorn",
      "name": "식스레그혼",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        3,
        10
      ],
      "sortedElementIds": [
        3,
        10
      ],
      "elementNames": [
        "바람",
        "영혼"
      ],
      "elementCodes": [
        "wind",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 472,
        "atk": 1642,
        "def": 802,
        "mag": 472,
        "mr": 472,
        "spd": 642,
        "sum": 4502
      },
      "abilityId": 51,
      "abilityName": "무관심",
      "baseMoveId": 103010,
      "baseMoveName": "바람의 발톱",
      "ultMoveId": 103030,
      "ultMoveName": "바람의 심판",
      "breedingSeconds": 19800,
      "hatchingSeconds": 19800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000008,
          1003000008
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 뿔은 조금씩 자라고 있다.",
        "type": "뿔 드래곤",
        "feed": "신들린 호박",
        "weight": "200~250kg",
        "size": "2.6~3.1m",
        "obtain": "커다란 뿔과 푸른 보석이 박힌\\n황금빛 외형이 돋보이는 묵직한 알이다."
      }
    },
    {
      "id": 1003000009,
      "code": "applecheek",
      "name": "애플칙",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        3,
        5
      ],
      "sortedElementIds": [
        3,
        5
      ],
      "elementNames": [
        "바람",
        "땅"
      ],
      "elementCodes": [
        "wind",
        "earth"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 705,
        "atk": 745,
        "def": 755,
        "mag": 1045,
        "mr": 1045,
        "spd": 705,
        "sum": 5000
      },
      "abilityId": 25,
      "abilityName": "숲의 분노",
      "baseMoveId": 103020,
      "baseMoveName": "바람의 파동",
      "ultMoveId": 103040,
      "ultMoveName": "바람의 권능",
      "breedingSeconds": 28800,
      "hatchingSeconds": 28800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 31,
        "fixedProportion": 500,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000009,
          1003000009
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 양쪽에 큰 빨간 점들을 가지고 있다.",
        "type": "과일 드래곤",
        "feed": "사과",
        "weight": "70~90kg",
        "size": "1.6~2.1m",
        "obtain": "사과처럼 달콤한 향기를 풍긴다."
      }
    },
    {
      "id": 1003000010,
      "code": "beleth",
      "name": "벨레드",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        3,
        8
      ],
      "sortedElementIds": [
        3,
        8
      ],
      "elementNames": [
        "바람",
        "어둠"
      ],
      "elementCodes": [
        "wind",
        "dark"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 562,
        "atk": 842,
        "def": 1122,
        "mag": 472,
        "mr": 512,
        "spd": 492,
        "sum": 4002
      },
      "abilityId": 10,
      "abilityName": "천리안",
      "baseMoveId": 103010,
      "baseMoveName": "바람의 발톱",
      "ultMoveId": 103030,
      "ultMoveName": "바람의 심판",
      "breedingSeconds": 27900,
      "hatchingSeconds": 27900,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000010,
          1003000010
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 부정한 기운을 느낀다.",
        "type": "악몽 드래곤",
        "feed": "어둠의 멜론",
        "weight": "150~180kg",
        "size": "3.0~3.3m",
        "obtain": "6개의 눈이 달린 기괴한 외형은\\n보는 이에게 공포를 심어준다."
      }
    },
    {
      "id": 1003000011,
      "code": "totemdragon",
      "name": "토템 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        3,
        9
      ],
      "sortedElementIds": [
        3,
        9
      ],
      "elementNames": [
        "바람",
        "꿈"
      ],
      "elementCodes": [
        "wind",
        "dream"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 387,
        "atk": 557,
        "def": 307,
        "mag": 1227,
        "mr": 887,
        "spd": 637,
        "sum": 4002
      },
      "abilityId": 42,
      "abilityName": "치유의 비",
      "baseMoveId": 103020,
      "baseMoveName": "바람의 파동",
      "ultMoveId": 103040,
      "ultMoveName": "바람의 권능",
      "breedingSeconds": 9000,
      "hatchingSeconds": 9000,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000011,
          1003000011
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 매우 날카로운 깃털이 꽂혀있다.",
        "type": "소원 드래곤",
        "feed": "단풍잎",
        "weight": "250~290kg",
        "size": "2.3~2.9m",
        "obtain": "위협을 느끼면 깃털을 세워 주변을 경계한다."
      }
    },
    {
      "id": 1003000012,
      "code": "plumos",
      "name": "플루모스",
      "rarity": 5,
      "tier": 8,
      "elementIds": [
        3,
        2,
        5
      ],
      "sortedElementIds": [
        2,
        3,
        5
      ],
      "elementNames": [
        "바람",
        "물",
        "땅"
      ],
      "elementCodes": [
        "wind",
        "water",
        "earth"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 763,
        "atk": 1933,
        "def": 1093,
        "mag": 763,
        "mr": 763,
        "spd": 933,
        "sum": 6248
      },
      "abilityId": 9,
      "abilityName": "절대기류",
      "baseMoveId": 103010,
      "baseMoveName": "바람의 발톱",
      "ultMoveId": 103103,
      "ultMoveName": "만개",
      "breedingSeconds": 51300,
      "hatchingSeconds": 51300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 13,
        "fixedProportion": 75,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1003000012,
          1003000012
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 매화는 피어나고 있다.",
        "type": "꽃 드래곤",
        "feed": "풀잎",
        "weight": "200~220kg",
        "size": "3.5~3.9m",
        "obtain": "알에 돋아난 매화나무는 부화 전까지 계속 자라난다."
      }
    },
    {
      "id": 1004000001,
      "code": "iron",
      "name": "아이언 드래곤",
      "rarity": 3,
      "tier": 1,
      "elementIds": [
        4
      ],
      "sortedElementIds": [
        4
      ],
      "elementNames": [
        "강철"
      ],
      "elementCodes": [
        "steel"
      ],
      "elementCount": 1,
      "stats": {
        "hp": 335,
        "atk": 585,
        "def": 835,
        "mag": 415,
        "mr": 665,
        "spd": 166,
        "sum": 3001
      },
      "abilityId": 15,
      "abilityName": "여유로움",
      "baseMoveId": 104010,
      "baseMoveName": "강철의 발톱",
      "ultMoveId": 104030,
      "ultMoveName": "강철의 심판",
      "breedingSeconds": 1350,
      "hatchingSeconds": 1350,
      "buyable": true,
      "buyItems": "6002010001;20000",
      "canBreedAsParent": true,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 8,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1004000001,
          1004000001
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 매우 붉고 검은색의 무언가가 튀어나와 있다.",
        "type": "환상 드래곤",
        "feed": "기름",
        "weight": "450~500kg",
        "size": "3.1~3.4m",
        "obtain": "알 표면은 금속 소재로 이루어져 있어\\n어떤 충격에도 깨지지 않는다."
      }
    },
    {
      "id": 1004000002,
      "code": "knightdragon",
      "name": "나이트 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        4,
        10
      ],
      "sortedElementIds": [
        4,
        10
      ],
      "elementNames": [
        "강철",
        "영혼"
      ],
      "elementCodes": [
        "steel",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 667,
        "atk": 667,
        "def": 667,
        "mag": 667,
        "mr": 667,
        "spd": 667,
        "sum": 4002
      },
      "abilityId": 4,
      "abilityName": "강심장",
      "baseMoveId": 104010,
      "baseMoveName": "강철의 발톱",
      "ultMoveId": 104030,
      "ultMoveName": "강철의 심판",
      "breedingSeconds": 19800,
      "hatchingSeconds": 19800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1004000002,
          1004000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 빛나는 투구를 쓰고 있다.",
        "type": "기사 드래곤",
        "feed": "꽃게",
        "weight": "380~420kg",
        "size": "2.5~3.2m",
        "obtain": "묵직한 강철 투구를 쓰고 있으며\\n고결한 기사의 기운이 서린 알이다."
      }
    },
    {
      "id": 1004000003,
      "code": "sharptail",
      "name": "샤프테일",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        4,
        5
      ],
      "sortedElementIds": [
        4,
        5
      ],
      "elementNames": [
        "강철",
        "땅"
      ],
      "elementCodes": [
        "steel",
        "earth"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 448,
        "atk": 1108,
        "def": 2278,
        "mag": 278,
        "mr": 278,
        "spd": 108,
        "sum": 4498
      },
      "abilityId": 8,
      "abilityName": "날카로운 비늘",
      "baseMoveId": 104010,
      "baseMoveName": "강철의 발톱",
      "ultMoveId": 104030,
      "ultMoveName": "강철의 심판",
      "breedingSeconds": 16650,
      "hatchingSeconds": 16650,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1004000003,
          1004000003
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 사납다.",
        "type": "칼날 드래곤",
        "feed": "파오파오 열매",
        "weight": "250~300kg",
        "size": "2.3~2.5m",
        "obtain": "알 껍질에서부터 범상치 않은 사나움이 느껴진다."
      }
    },
    {
      "id": 1004000004,
      "code": "dragonoid",
      "name": "드라고노이드",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        4,
        6
      ],
      "sortedElementIds": [
        4,
        6
      ],
      "elementNames": [
        "강철",
        "번개"
      ],
      "elementCodes": [
        "steel",
        "lightning"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 613,
        "atk": 943,
        "def": 943,
        "mag": 1443,
        "mr": 613,
        "spd": 443,
        "sum": 4998
      },
      "abilityId": 36,
      "abilityName": "자력장",
      "baseMoveId": 104020,
      "baseMoveName": "강철의 파동",
      "ultMoveId": 104040,
      "ultMoveName": "강철의 권능",
      "breedingSeconds": 29700,
      "hatchingSeconds": 29700,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 12,
      "breeding": {
        "portion": 31,
        "fixedProportion": 500,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1004000004,
          1004000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 강철로 이루어져 있다.",
        "type": "로봇 드래곤",
        "feed": "퍼플튤립",
        "weight": "300~350kg",
        "size": "2.8~3.0m",
        "obtain": "은색 강철과 청록빛 금속이 결합된 표면은\\n차갑고 매끈한 촉감을 지녔다."
      }
    },
    {
      "id": 1004000005,
      "code": "blackarmor",
      "name": "블랙아머",
      "rarity": 4,
      "tier": 7,
      "elementIds": [
        4,
        8,
        10
      ],
      "sortedElementIds": [
        4,
        8,
        10
      ],
      "elementNames": [
        "강철",
        "어둠",
        "영혼"
      ],
      "elementCodes": [
        "steel",
        "dark",
        "soul"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 663,
        "atk": 1583,
        "def": 1503,
        "mag": 913,
        "mr": 833,
        "spd": 503,
        "sum": 5998
      },
      "abilityId": 50,
      "abilityName": "강인한 의지",
      "baseMoveId": 104010,
      "baseMoveName": "강철의 발톱",
      "ultMoveId": 104103,
      "ultMoveName": "흑기사",
      "breedingSeconds": 56700,
      "hatchingSeconds": 56700,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 19,
        "fixedProportion": 150,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1004000005,
          1004000005
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 투구를 쓰고 있다.",
        "type": "기사 드래곤",
        "feed": "드래곤에그베리",
        "weight": "400~420kg",
        "size": "3.1~3.4m",
        "obtain": "은색의 투구를 쓰고 있으며\\n가운데에는 붉은 보석이 박혀 있는 알이다."
      }
    },
    {
      "id": 1004000006,
      "code": "fat",
      "name": "패트",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        4,
        9
      ],
      "sortedElementIds": [
        4,
        9
      ],
      "elementNames": [
        "강철",
        "꿈"
      ],
      "elementCodes": [
        "steel",
        "dream"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 248,
        "atk": 1168,
        "def": 1498,
        "mag": 338,
        "mr": 998,
        "spd": 248,
        "sum": 4498
      },
      "abilityId": 6,
      "abilityName": "광분",
      "baseMoveId": 104010,
      "baseMoveName": "강철의 발톱",
      "ultMoveId": 104030,
      "ultMoveName": "강철의 심판",
      "breedingSeconds": 27000,
      "hatchingSeconds": 27000,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1004000006,
          1004000006
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 방패와 함께다.",
        "type": "잠 드래곤",
        "feed": "모든 음식",
        "weight": "490~520kg",
        "size": "3.5~3.9m",
        "obtain": "바위와 같은 회색에 단단한 방패가 붙어있는 알이다."
      }
    },
    {
      "id": 1004000007,
      "code": "obex",
      "name": "오벡스",
      "rarity": 5,
      "tier": 8,
      "elementIds": [
        4,
        6,
        8
      ],
      "sortedElementIds": [
        4,
        6,
        8
      ],
      "elementNames": [
        "강철",
        "번개",
        "어둠"
      ],
      "elementCodes": [
        "steel",
        "lightning",
        "dark"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 822,
        "atk": 1152,
        "def": 1152,
        "mag": 1652,
        "mr": 822,
        "spd": 652,
        "sum": 6252
      },
      "abilityId": 20,
      "abilityName": "공중부양",
      "baseMoveId": 104020,
      "baseMoveName": "강철의 파동",
      "ultMoveId": 104106,
      "ultMoveName": "레일건 임팩트",
      "breedingSeconds": 51300,
      "hatchingSeconds": 51300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1004000007,
          1004000007
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 공간을 생성하려 한다.",
        "type": "공간 드래곤",
        "feed": "어둠의 멜론",
        "weight": "50~70kg",
        "size": "1.4~1.7m",
        "obtain": "스스로 공간을 생성하려는 본능을 품은\\n신비롭고 기묘한 알이다."
      }
    },
    {
      "id": 1005000001,
      "code": "rock",
      "name": "바위 드래곤",
      "rarity": 3,
      "tier": 1,
      "elementIds": [
        5
      ],
      "sortedElementIds": [
        5
      ],
      "elementNames": [
        "땅"
      ],
      "elementCodes": [
        "earth"
      ],
      "elementCount": 1,
      "stats": {
        "hp": 388,
        "atk": 1308,
        "def": 388,
        "mag": 388,
        "mr": 388,
        "spd": 139,
        "sum": 2999
      },
      "abilityId": 23,
      "abilityName": "내열성 외피",
      "baseMoveId": 105010,
      "baseMoveName": "땅의 발톱",
      "ultMoveId": 105030,
      "ultMoveName": "땅의 심판",
      "breedingSeconds": 3600,
      "hatchingSeconds": 3600,
      "buyable": true,
      "buyItems": "6002010001;30000",
      "canBreedAsParent": true,
      "requireUserLevel": 10,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1005000001,
          1005000001
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 곡괭이가 필요하다.",
        "type": "암석 드래곤",
        "feed": "광석",
        "weight": "2~3t",
        "size": "3.1~4.8m",
        "obtain": "암석이 박혀 있으며 뿔이 돋아난 단단한 알이다."
      }
    },
    {
      "id": 1005000002,
      "code": "mustardhammer",
      "name": "머스타드해머",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        5,
        9
      ],
      "sortedElementIds": [
        5,
        9
      ],
      "elementNames": [
        "땅",
        "꿈"
      ],
      "elementCodes": [
        "earth",
        "dream"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 553,
        "atk": 723,
        "def": 1223,
        "mag": 53,
        "mr": 553,
        "spd": 893,
        "sum": 3998
      },
      "abilityId": 4,
      "abilityName": "강심장",
      "baseMoveId": 105010,
      "baseMoveName": "땅의 발톱",
      "ultMoveId": 105030,
      "ultMoveName": "땅의 심판",
      "breedingSeconds": 26550,
      "hatchingSeconds": 26550,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1005000002,
          1005000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 매우 강한 힘을 품고 있다.",
        "type": "땅 드래곤",
        "feed": "파오파오 열매",
        "weight": "190~230kg",
        "size": "1.8~2.2m",
        "obtain": "주로 흙 속에 교묘히 숨겨져 있어\\n발견하기 매우 어려운 알이다."
      }
    },
    {
      "id": 1005000003,
      "code": "egg",
      "name": "에그 드래곤",
      "rarity": 4,
      "tier": 6,
      "elementIds": [
        5,
        1
      ],
      "sortedElementIds": [
        1,
        5
      ],
      "elementNames": [
        "땅",
        "불"
      ],
      "elementCodes": [
        "earth",
        "fire"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1258,
        "atk": 1328,
        "def": 1428,
        "mag": 588,
        "mr": 658,
        "spd": 238,
        "sum": 5498
      },
      "abilityId": 6,
      "abilityName": "광분",
      "baseMoveId": 105010,
      "baseMoveName": "땅의 발톱",
      "ultMoveId": 105030,
      "ultMoveName": "땅의 심판",
      "breedingSeconds": 7200,
      "hatchingSeconds": 7200,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1005000003,
          1005000003
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 표면은 침이 묻어 있다.",
        "type": "알 드래곤",
        "feed": "드래곤에그베리",
        "weight": "165~180kg",
        "size": "2.1~2.5m",
        "obtain": "매우 단단하고 열과 냉기에 강하며\\n어떤 충격으로도 부술 수 없는 알이다."
      }
    },
    {
      "id": 1005000004,
      "code": "mushroom",
      "name": "머쉬룸 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        5,
        7
      ],
      "sortedElementIds": [
        5,
        7
      ],
      "elementNames": [
        "땅",
        "빛"
      ],
      "elementCodes": [
        "earth",
        "light"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1248,
        "atk": 748,
        "def": 748,
        "mag": 418,
        "mr": 418,
        "spd": 418,
        "sum": 3998
      },
      "abilityId": 17,
      "abilityName": "내성",
      "baseMoveId": 105010,
      "baseMoveName": "땅의 발톱",
      "ultMoveId": 105030,
      "ultMoveName": "땅의 심판",
      "breedingSeconds": 15750,
      "hatchingSeconds": 15750,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1005000004,
          1005000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 촉촉하며 탱글거린다.",
        "type": "버섯 드래곤",
        "feed": "버섯",
        "weight": "130~150kg",
        "size": "2.1~2.8m",
        "obtain": "버섯과 흡사한 모양을 가지고 있\\n실제 버섯과 구분이 어려울 수 있다."
      }
    },
    {
      "id": 1005000005,
      "code": "lakion",
      "name": "라키온",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        5,
        6
      ],
      "sortedElementIds": [
        5,
        6
      ],
      "elementNames": [
        "땅",
        "번개"
      ],
      "elementCodes": [
        "earth",
        "lightning"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 737,
        "atk": 817,
        "def": 657,
        "mag": 567,
        "mr": 737,
        "spd": 987,
        "sum": 4502
      },
      "abilityId": 18,
      "abilityName": "동화",
      "baseMoveId": 105010,
      "baseMoveName": "땅의 발톱",
      "ultMoveId": 105030,
      "ultMoveName": "땅의 심판",
      "breedingSeconds": 19800,
      "hatchingSeconds": 19800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 12,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1005000005,
          1005000005
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 후드를 뒤집어쓰고 있다.",
        "type": "보따리 드래곤",
        "feed": "신들린 호박",
        "weight": "190~230kg",
        "size": "2~2.3m",
        "obtain": "후드를 뒤집어쓴 알이다."
      }
    },
    {
      "id": 1005000006,
      "code": "leafdragon",
      "name": "리프 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        5,
        3
      ],
      "sortedElementIds": [
        3,
        5
      ],
      "elementNames": [
        "땅",
        "바람"
      ],
      "elementCodes": [
        "earth",
        "wind"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 307,
        "atk": 386,
        "def": 307,
        "mag": 1476,
        "mr": 386,
        "spd": 1136,
        "sum": 3998
      },
      "abilityId": 15,
      "abilityName": "여유로움",
      "baseMoveId": 105020,
      "baseMoveName": "땅의 파동",
      "ultMoveId": 105040,
      "ultMoveName": "땅의 권능",
      "breedingSeconds": 11700,
      "hatchingSeconds": 11700,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1005000006,
          1005000006
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 나뭇잎이 자라고 있다.",
        "type": "나뭇잎 드래곤",
        "feed": "풀잎",
        "weight": "50~70kg",
        "size": "1.7~2.1m",
        "obtain": "알에 나뭇잎이 자라나며 부화가 다가올수록\\n잎은 알을 가릴 정도로 커진다."
      }
    },
    {
      "id": 1005000008,
      "code": "scorpiondragon",
      "name": "스콜피온 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        5,
        8
      ],
      "sortedElementIds": [
        5,
        8
      ],
      "elementNames": [
        "땅",
        "어둠"
      ],
      "elementCodes": [
        "earth",
        "dark"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 688,
        "atk": 1058,
        "def": 438,
        "mag": 438,
        "mr": 438,
        "spd": 938,
        "sum": 3998
      },
      "abilityId": 17,
      "abilityName": "내성",
      "baseMoveId": 105010,
      "baseMoveName": "땅의 발톱",
      "ultMoveId": 105030,
      "ultMoveName": "땅의 심판",
      "breedingSeconds": 25650,
      "hatchingSeconds": 25650,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1005000008,
          1005000008
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 얼얼하다.",
        "type": "전갈 드래곤",
        "feed": "자몽",
        "weight": "80~100kg",
        "size": "1.4~2.0m",
        "obtain": "점박이 무늬가 새겨진 알로 은밀한 독성을 품고 있다."
      }
    },
    {
      "id": 1005000009,
      "code": "mud",
      "name": "머드 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        5,
        2
      ],
      "sortedElementIds": [
        2,
        5
      ],
      "elementNames": [
        "땅",
        "물"
      ],
      "elementCodes": [
        "earth",
        "water"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 805,
        "atk": 1395,
        "def": 655,
        "mag": 245,
        "mr": 655,
        "spd": 245,
        "sum": 4000
      },
      "abilityId": 3,
      "abilityName": "늪",
      "baseMoveId": 105010,
      "baseMoveName": "땅의 발톱",
      "ultMoveId": 105030,
      "ultMoveName": "땅의 심판",
      "breedingSeconds": 10800,
      "hatchingSeconds": 10800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1005000009,
          1005000009
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 진흙이 흘러내린다.",
        "type": "진흙 드래곤",
        "feed": "메기슨",
        "weight": "380~400kg",
        "size": "4.1~4.4m",
        "obtain": "진흙 같은 알 표면에 무늬가 새겨져 있으며\\n항상 촉촉한 수분을 머금고 있다."
      }
    },
    {
      "id": 1005000010,
      "code": "tumpy",
      "name": "텀피",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        5,
        10
      ],
      "sortedElementIds": [
        5,
        10
      ],
      "elementNames": [
        "땅",
        "영혼"
      ],
      "elementCodes": [
        "earth",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 507,
        "atk": 1087,
        "def": 657,
        "mag": 587,
        "mr": 827,
        "spd": 837,
        "sum": 4502
      },
      "abilityId": 10,
      "abilityName": "천리안",
      "baseMoveId": 105010,
      "baseMoveName": "땅의 발톱",
      "ultMoveId": 105030,
      "ultMoveName": "땅의 심판",
      "breedingSeconds": 27000,
      "hatchingSeconds": 27000,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1005000010,
          1005000010
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 잠시 앉아서 쉬고 싶은 마음을 들게 한다.",
        "type": "나무 드래곤",
        "feed": "새벽 이슬",
        "weight": "80~100kg",
        "size": "0.7m~1.0m",
        "obtain": "그루터기를 닮은 외형에 푸른 새싹이 돋아나 있다."
      }
    },
    {
      "id": 1005000011,
      "code": "power",
      "name": "파워 드래곤",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        5,
        4,
        7
      ],
      "sortedElementIds": [
        4,
        5,
        7
      ],
      "elementNames": [
        "땅",
        "강철",
        "빛"
      ],
      "elementCodes": [
        "earth",
        "steel",
        "light"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 1090,
        "atk": 1610,
        "def": 1235,
        "mag": 1005,
        "mr": 1090,
        "spd": 485,
        "sum": 6515
      },
      "abilityId": 24,
      "abilityName": "괴력",
      "baseMoveId": 105010,
      "baseMoveName": "땅의 발톱",
      "ultMoveId": 105104,
      "ultMoveName": "절명의 철권",
      "breedingSeconds": 57600,
      "hatchingSeconds": 57600,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1005000011,
          1005000011
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 매우 거칠고 무겁다.",
        "type": "힘 드래곤",
        "feed": "코코넛",
        "weight": "600~800kg",
        "size": "4.5~5.5m",
        "obtain": "어두운 바위 빛에 거친 표면과 점박이 무늬가 새겨진\\n투박한 알이다."
      }
    },
    {
      "id": 1006000001,
      "code": "bluethunder",
      "name": "블루썬더",
      "rarity": 3,
      "tier": 1,
      "elementIds": [
        6
      ],
      "sortedElementIds": [
        6
      ],
      "elementNames": [
        "번개"
      ],
      "elementCodes": [
        "lightning"
      ],
      "elementCount": 1,
      "stats": {
        "hp": 315,
        "atk": 655,
        "def": 405,
        "mag": 485,
        "mr": 405,
        "spd": 735,
        "sum": 3000
      },
      "abilityId": 9,
      "abilityName": "절대기류",
      "baseMoveId": 106010,
      "baseMoveName": "번개의 발톱",
      "ultMoveId": 106030,
      "ultMoveName": "번개의 심판",
      "breedingSeconds": 9900,
      "hatchingSeconds": 9900,
      "buyable": true,
      "buyItems": "6002010001;50000",
      "canBreedAsParent": true,
      "requireUserLevel": 12,
      "requireUserLevelByElement": 12,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1006000001,
          1006000001
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 주변으로 번개가 몰려온다.",
        "type": "섬광 드래곤",
        "feed": "메뚜기",
        "weight": "60~75kg",
        "size": "1.7~2m",
        "obtain": "푸른 번개를 머금은 뿔이 돋아나 있는 알이다."
      }
    },
    {
      "id": 1006000002,
      "code": "whitethunder",
      "name": "화이트썬더",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        6,
        7
      ],
      "sortedElementIds": [
        6,
        7
      ],
      "elementNames": [
        "번개",
        "빛"
      ],
      "elementCodes": [
        "lightning",
        "light"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 583,
        "atk": 1383,
        "def": 453,
        "mag": 913,
        "mr": 753,
        "spd": 913,
        "sum": 4998
      },
      "abilityId": 45,
      "abilityName": "재생",
      "baseMoveId": 106010,
      "baseMoveName": "번개의 발톱",
      "ultMoveId": 106030,
      "ultMoveName": "번개의 심판",
      "breedingSeconds": 23400,
      "hatchingSeconds": 23400,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 31,
        "fixedProportion": 500,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1006000002,
          1006000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 번개의 뿔이 감싸고 있다.",
        "type": "번개 드래곤",
        "feed": "무지개 꽃",
        "weight": "40~80kg",
        "size": "1.7~2.3m",
        "obtain": "푸른 빛을 내는 뿔이 알을 감싸 보호하고 있다."
      }
    },
    {
      "id": 1006000003,
      "code": "bluelightning",
      "name": "블루라이트닝",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        6,
        1
      ],
      "sortedElementIds": [
        1,
        6
      ],
      "elementNames": [
        "번개",
        "불"
      ],
      "elementCodes": [
        "lightning",
        "fire"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 470,
        "atk": 870,
        "def": 250,
        "mag": 700,
        "mr": 330,
        "spd": 1380,
        "sum": 4000
      },
      "abilityId": 43,
      "abilityName": "충전",
      "baseMoveId": 106010,
      "baseMoveName": "번개의 발톱",
      "ultMoveId": 106030,
      "ultMoveName": "번개의 심판",
      "breedingSeconds": 8100,
      "hatchingSeconds": 8100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 12,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1006000003,
          1006000003
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 전류가 흐른다.",
        "type": "전기 드래곤",
        "feed": "망고",
        "weight": "320~360kg",
        "size": "2.4~2.8m",
        "obtain": "알 표면에 강력한 전류가 흐르고 있어\\n함부로 만지면 위험한 알이다."
      }
    },
    {
      "id": 1006000004,
      "code": "taabire",
      "name": "타아비레",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        6,
        10
      ],
      "sortedElementIds": [
        6,
        10
      ],
      "elementNames": [
        "번개",
        "영혼"
      ],
      "elementCodes": [
        "lightning",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 480,
        "atk": 810,
        "def": 560,
        "mag": 810,
        "mr": 560,
        "spd": 1280,
        "sum": 4500
      },
      "abilityId": 2,
      "abilityName": "속도광",
      "baseMoveId": 106010,
      "baseMoveName": "번개의 발톱",
      "ultMoveId": 106030,
      "ultMoveName": "번개의 심판",
      "breedingSeconds": 27900,
      "hatchingSeconds": 27900,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1006000004,
          1006000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 주변으로 정전기가 감싸고 있다.",
        "type": "번개 드래곤",
        "feed": "메뚜기",
        "weight": "120~170kg",
        "size": "2.1~2.8m",
        "obtain": "뿔 사이로 강력한 전류가 흐르며 알을 보호한다."
      }
    },
    {
      "id": 1006000005,
      "code": "thunderboltdragon",
      "name": "썬더볼트 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        6,
        2
      ],
      "sortedElementIds": [
        2,
        6
      ],
      "elementNames": [
        "번개",
        "물"
      ],
      "elementCodes": [
        "lightning",
        "water"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 277,
        "atk": 277,
        "def": 727,
        "mag": 1027,
        "mr": 727,
        "spd": 967,
        "sum": 4002
      },
      "abilityId": 41,
      "abilityName": "전격피부",
      "baseMoveId": 106020,
      "baseMoveName": "번개의 파동",
      "ultMoveId": 106040,
      "ultMoveName": "번개의 권능",
      "breedingSeconds": 13500,
      "hatchingSeconds": 13500,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 12,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1006000005,
          1006000005
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 강한 전기가 둘러싸여 있다.",
        "type": "번개 드래곤",
        "feed": "피라냐",
        "weight": "100~130kg",
        "size": "2.4~2.7m",
        "obtain": "미세한 전류가 알 전체를 감싸며\\n보호막을 형성하고 있다."
      }
    },
    {
      "id": 1006000006,
      "code": "lightning",
      "name": "번개고룡",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        6,
        1,
        7
      ],
      "sortedElementIds": [
        1,
        6,
        7
      ],
      "elementNames": [
        "번개",
        "불",
        "빛"
      ],
      "elementCodes": [
        "lightning",
        "fire",
        "light"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 972,
        "atk": 972,
        "def": 892,
        "mag": 1552,
        "mr": 972,
        "spd": 1142,
        "sum": 6502
      },
      "abilityId": 48,
      "abilityName": "절연체",
      "baseMoveId": 106020,
      "baseMoveName": "번개의 파동",
      "ultMoveId": 106103,
      "ultMoveName": "썬더스톰",
      "breedingSeconds": 61200,
      "hatchingSeconds": 61200,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1006000006,
          1006000006
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 문양은 매우 저릿하다.",
        "type": "번개 드래곤",
        "feed": "메뚜기",
        "weight": "120~170kg",
        "size": "2.7~3.1m",
        "obtain": "번개 보석에서 흐르는 정전기는\\n웬만한 강인함 없이는 견뎌내기 힘들다."
      }
    },
    {
      "id": 1006000008,
      "code": "splender",
      "name": "스플렌더",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        6,
        4
      ],
      "sortedElementIds": [
        4,
        6
      ],
      "elementNames": [
        "번개",
        "강철"
      ],
      "elementCodes": [
        "lightning",
        "steel"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 468,
        "atk": 888,
        "def": 1388,
        "mag": 808,
        "mr": 558,
        "spd": 388,
        "sum": 4498
      },
      "abilityId": 51,
      "abilityName": "무관심",
      "baseMoveId": 106010,
      "baseMoveName": "번개의 발톱",
      "ultMoveId": 106030,
      "ultMoveName": "번개의 심판",
      "breedingSeconds": 25200,
      "hatchingSeconds": 25200,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 12,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1006000008,
          1006000008
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 오색찬란한 빛을 갖고 있다.",
        "type": "오색빛 드래곤",
        "feed": "회오리 꽃",
        "weight": "180~200kg",
        "size": "2.5~3.0m",
        "obtain": "찬란하고 알록달록한 빛을 내뿜으며\\n주변에 생기 넘치는 기운을 전달하는 알이다."
      }
    },
    {
      "id": 1006000009,
      "code": "bluefiretail",
      "name": "청불나래",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        6,
        3
      ],
      "sortedElementIds": [
        3,
        6
      ],
      "elementNames": [
        "번개",
        "바람"
      ],
      "elementCodes": [
        "lightning",
        "wind"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 625,
        "atk": 375,
        "def": 795,
        "mag": 375,
        "mr": 1125,
        "spd": 1205,
        "sum": 4500
      },
      "abilityId": 40,
      "abilityName": "급소 회피",
      "baseMoveId": 106010,
      "baseMoveName": "번개의 발톱",
      "ultMoveId": 106030,
      "ultMoveName": "번개의 심판",
      "breedingSeconds": 26100,
      "hatchingSeconds": 26100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 12,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1006000009,
          1006000009
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 검푸른 털은 매우 부드럽다.",
        "type": "구미호 드래곤",
        "feed": "불당근",
        "weight": "120~150kg",
        "size": "2.4~2.8m",
        "obtain": "알을 뒤덮고 있는 털은 부드럽고\\n포근한 촉감을 지니고 있다."
      }
    },
    {
      "id": 1006000010,
      "code": "cloud",
      "name": "클라우드 드래곤",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        6,
        2
      ],
      "sortedElementIds": [
        2,
        6
      ],
      "elementNames": [
        "번개",
        "물"
      ],
      "elementCodes": [
        "lightning",
        "water"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 823,
        "atk": 1323,
        "def": 733,
        "mag": 1153,
        "mr": 733,
        "spd": 233,
        "sum": 4998
      },
      "abilityId": 27,
      "abilityName": "태풍",
      "baseMoveId": 106010,
      "baseMoveName": "번개의 발톱",
      "ultMoveId": 106030,
      "ultMoveName": "번개의 심판",
      "breedingSeconds": 27900,
      "hatchingSeconds": 27900,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 12,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1006000010,
          1006000010
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 구름과 함께다.",
        "type": "구름 드래곤",
        "feed": "회오리 꽃",
        "weight": "120~250kg",
        "size": "1.3~2.1m",
        "obtain": "소용돌이치는 구름에 감싸져 있으며\\n더듬이가 솟아 있다."
      }
    },
    {
      "id": 1007000002,
      "code": "rafael",
      "name": "라파엘",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        7,
        10
      ],
      "sortedElementIds": [
        7,
        10
      ],
      "elementNames": [
        "빛",
        "영혼"
      ],
      "elementCodes": [
        "light",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1182,
        "atk": 1762,
        "def": 1012,
        "mag": 352,
        "mr": 512,
        "spd": 182,
        "sum": 5002
      },
      "abilityId": 13,
      "abilityName": "차력",
      "baseMoveId": 107010,
      "baseMoveName": "빛의 발톱",
      "ultMoveId": 107030,
      "ultMoveName": "빛의 심판",
      "breedingSeconds": 28800,
      "hatchingSeconds": 28800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 31,
        "fixedProportion": 500,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1007000002,
          1007000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 보석과 같이 빛난다.",
        "type": "자애 드래곤",
        "feed": "포도",
        "weight": "150~180kg",
        "size": "1.6~2.3m",
        "obtain": "알 표면에 신성하고 귀한 보석이 박혀 있어\\n영롱한 빛을 발한다."
      }
    },
    {
      "id": 1007000003,
      "code": "haze",
      "name": "헤이즈",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        7,
        2
      ],
      "sortedElementIds": [
        2,
        7
      ],
      "elementNames": [
        "빛",
        "물"
      ],
      "elementCodes": [
        "light",
        "water"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 362,
        "atk": 442,
        "def": 362,
        "mag": 1532,
        "mr": 612,
        "spd": 1192,
        "sum": 4502
      },
      "abilityId": 37,
      "abilityName": "정화",
      "baseMoveId": 107020,
      "baseMoveName": "빛의 파동",
      "ultMoveId": 107040,
      "ultMoveName": "빛의 권능",
      "breedingSeconds": 21600,
      "hatchingSeconds": 21600,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1007000003,
          1007000003
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 안개가 자욱하다.",
        "type": "비행 드래곤",
        "feed": "스타후르츠",
        "weight": "30~50kg",
        "size": "1.6~2.1m",
        "obtain": "언제나 자욱한 안개에 싸여 있으며\\n알 주변으로 끊임없이 뿌연 안개가 피어오른다."
      }
    },
    {
      "id": 1007000004,
      "code": "emerald",
      "name": "에메랄드 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        7,
        4
      ],
      "sortedElementIds": [
        4,
        7
      ],
      "elementNames": [
        "빛",
        "강철"
      ],
      "elementCodes": [
        "light",
        "steel"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 377,
        "atk": 1037,
        "def": 377,
        "mag": 1127,
        "mr": 377,
        "spd": 707,
        "sum": 4002
      },
      "abilityId": 49,
      "abilityName": "행운아",
      "baseMoveId": 107020,
      "baseMoveName": "빛의 파동",
      "ultMoveId": 107040,
      "ultMoveName": "빛의 권능",
      "breedingSeconds": 24300,
      "hatchingSeconds": 24300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1007000004,
          1007000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 약간 푸르고, 왕관이 달려있다.",
        "type": "빛 드래곤",
        "feed": "파오파오 열매",
        "weight": "290~310kg",
        "size": "3.6~4.1m",
        "obtain": "알 중앙의 보석을 제외한 표면은 매우 차갑고 얇아\\n부서지기 쉽다."
      }
    },
    {
      "id": 1007000005,
      "code": "ilios",
      "name": "일리오스",
      "rarity": 3,
      "tier": 1,
      "elementIds": [
        7
      ],
      "sortedElementIds": [
        7
      ],
      "elementNames": [
        "빛"
      ],
      "elementCodes": [
        "light"
      ],
      "elementCount": 1,
      "stats": {
        "hp": 1150,
        "atk": 820,
        "def": 559,
        "mag": 1,
        "mr": 559,
        "spd": 1,
        "sum": 3090
      },
      "abilityId": 21,
      "abilityName": "불쏘시개",
      "baseMoveId": 107010,
      "baseMoveName": "빛의 발톱",
      "ultMoveId": 107030,
      "ultMoveName": "빛의 심판",
      "breedingSeconds": 25200,
      "hatchingSeconds": 25200,
      "buyable": true,
      "buyItems": "6002010001;100000",
      "canBreedAsParent": true,
      "requireUserLevel": 14,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1007000005,
          1007000005
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 타오르고 있다.",
        "type": "시간 드래곤",
        "feed": "불멜론",
        "weight": "410~450kg",
        "size": "3.2~3.8m",
        "obtain": "알 전체가 일렁이는 불길에 휩싸여 있으며\\n햇빛에 반응한다."
      }
    },
    {
      "id": 1007000006,
      "code": "spicy",
      "name": "스파이시",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        7,
        10
      ],
      "sortedElementIds": [
        7,
        10
      ],
      "elementNames": [
        "빛",
        "영혼"
      ],
      "elementCodes": [
        "light",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 701,
        "atk": 1531,
        "def": 701,
        "mag": 1,
        "mr": 701,
        "spd": 871,
        "sum": 4506
      },
      "abilityId": 19,
      "abilityName": "명사수",
      "baseMoveId": 107010,
      "baseMoveName": "빛의 발톱",
      "ultMoveId": 107030,
      "ultMoveName": "빛의 심판",
      "breedingSeconds": 26100,
      "hatchingSeconds": 26100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1007000006,
          1007000006
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 빛에 닿고 싶어 한다.",
        "type": "빛 드래곤",
        "feed": "포도",
        "weight": "230~250kg",
        "size": "3.6~4m",
        "obtain": "알 중앙에 보석이 박혀 있으며, 떨어져 나가도\\n금방 다시 생성될 만큼 재생력이 강하다."
      }
    },
    {
      "id": 1007000007,
      "code": "dilrang",
      "name": "딜랑",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        7,
        6
      ],
      "sortedElementIds": [
        6,
        7
      ],
      "elementNames": [
        "빛",
        "번개"
      ],
      "elementCodes": [
        "light",
        "lightning"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 612,
        "atk": 612,
        "def": 862,
        "mag": 612,
        "mr": 862,
        "spd": 942,
        "sum": 4502
      },
      "abilityId": 2,
      "abilityName": "속도광",
      "baseMoveId": 107010,
      "baseMoveName": "빛의 발톱",
      "ultMoveId": 107030,
      "ultMoveName": "빛의 심판",
      "breedingSeconds": 24750,
      "hatchingSeconds": 24750,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1007000007,
          1007000007
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 강렬한 빛을 내뿜는 장식이 새겨져있다.",
        "type": "비행 드래곤",
        "feed": "멜론",
        "weight": "100~110kg",
        "size": "2.4.~2.7m",
        "obtain": "비행하기 좋은 날씨에 눈부신 빛이 뿜어져 나온다."
      }
    },
    {
      "id": 1007000008,
      "code": "solar",
      "name": "솔라 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        7,
        10
      ],
      "sortedElementIds": [
        7,
        10
      ],
      "elementNames": [
        "빛",
        "영혼"
      ],
      "elementCodes": [
        "light",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 960,
        "atk": 1290,
        "def": 960,
        "mag": 210,
        "mr": 370,
        "spd": 210,
        "sum": 4000
      },
      "abilityId": 1,
      "abilityName": "일출",
      "baseMoveId": 107010,
      "baseMoveName": "빛의 발톱",
      "ultMoveId": 107030,
      "ultMoveName": "빛의 심판",
      "breedingSeconds": 29700,
      "hatchingSeconds": 29700,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1007000008,
          1007000008
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 빛을 전해준다.",
        "type": "태양 드래곤",
        "feed": "멜론",
        "weight": "250~330kg",
        "size": "3.3~3.5m",
        "obtain": "주변에 온기를 전하는 빛을 발산하며\\n태양의 에너지를 가득 머금고 있다."
      }
    },
    {
      "id": 1007000009,
      "code": "selora",
      "name": "셀오라",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        7,
        6,
        2
      ],
      "sortedElementIds": [
        2,
        6,
        7
      ],
      "elementNames": [
        "빛",
        "번개",
        "물"
      ],
      "elementCodes": [
        "light",
        "lightning",
        "water"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 890,
        "atk": 1640,
        "def": 890,
        "mag": 890,
        "mr": 720,
        "spd": 1470,
        "sum": 6500
      },
      "abilityId": 37,
      "abilityName": "정화",
      "baseMoveId": 107010,
      "baseMoveName": "빛의 발톱",
      "ultMoveId": 107103,
      "ultMoveName": "정화 폭발",
      "breedingSeconds": 60300,
      "hatchingSeconds": 60300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1007000009,
          1007000009
        ]
      },
      "drop": "gacha_pickup",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 신령스러운 힘을 품고 있다.",
        "type": "정화 드래곤",
        "feed": "무지개 꽃",
        "weight": "0.8~1.0t",
        "size": "2.8~3.3m",
        "obtain": "고목이 잠든 자리에서 피어나는 알로\\n신령한 빛을 내뿜는다."
      }
    },
    {
      "id": 1008000002,
      "code": "catsgon",
      "name": "캣츠곤",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        8,
        10
      ],
      "sortedElementIds": [
        8,
        10
      ],
      "elementNames": [
        "어둠",
        "영혼"
      ],
      "elementCodes": [
        "dark",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1100,
        "atk": 1510,
        "def": 300,
        "mag": 1180,
        "mr": 300,
        "spd": 610,
        "sum": 5000
      },
      "abilityId": 14,
      "abilityName": "냉기저항",
      "baseMoveId": 108010,
      "baseMoveName": "어둠의 발톱",
      "ultMoveId": 108030,
      "ultMoveName": "어둠의 심판",
      "breedingSeconds": 30600,
      "hatchingSeconds": 30600,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 31,
        "fixedProportion": 500,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000002,
          1008000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 작은 방울이 달려있다.",
        "type": "고양이 드래곤",
        "feed": "육포",
        "weight": "70~100kg",
        "size": "1.7~2.3m",
        "obtain": "부드러운 털로 덮인 이 알은 만질 때마다\\n맑은 방울 소리가 난다."
      }
    },
    {
      "id": 1008000003,
      "code": "lunera",
      "name": "루네라",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        8,
        7
      ],
      "sortedElementIds": [
        7,
        8
      ],
      "elementNames": [
        "어둠",
        "빛"
      ],
      "elementCodes": [
        "dark",
        "light"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 552,
        "atk": 1552,
        "def": 1142,
        "mag": 472,
        "mr": 642,
        "spd": 642,
        "sum": 5002
      },
      "abilityId": 51,
      "abilityName": "무관심",
      "baseMoveId": 108010,
      "baseMoveName": "어둠의 발톱",
      "ultMoveId": 108030,
      "ultMoveName": "어둠의 심판",
      "breedingSeconds": 29700,
      "hatchingSeconds": 29700,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000003,
          1008000003
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 달 모양의 보석을 가지고 있다.",
        "type": "달 드래곤",
        "feed": "퍼플튤립",
        "weight": "310~330kg",
        "size": "2.7~3.1m",
        "obtain": "달의 힘을 담은 보석이 박혀 빛나는 신비로운 알이다."
      }
    },
    {
      "id": 1008000004,
      "code": "serpentdragon",
      "name": "서펀트 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        8,
        2
      ],
      "sortedElementIds": [
        2,
        8
      ],
      "elementNames": [
        "어둠",
        "물"
      ],
      "elementCodes": [
        "dark",
        "water"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 392,
        "atk": 1052,
        "def": 392,
        "mag": 52,
        "mr": 722,
        "spd": 1392,
        "sum": 4002
      },
      "abilityId": 35,
      "abilityName": "피로 회복",
      "baseMoveId": 108010,
      "baseMoveName": "어둠의 발톱",
      "ultMoveId": 108030,
      "ultMoveName": "어둠의 심판",
      "breedingSeconds": 24300,
      "hatchingSeconds": 24300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000004,
          1008000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 얇은 비늘로 이루어져 있다.",
        "type": "뱀 드래곤",
        "feed": "퍼플튤립",
        "weight": "300~360kg",
        "size": "2.8~3.3m",
        "obtain": "얇은 비늘로 덮인 이 알은 가까이 대면\\n쉭쉭거리는 소리가 들린다."
      }
    },
    {
      "id": 1008000005,
      "code": "baal",
      "name": "바알",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        8,
        6
      ],
      "sortedElementIds": [
        6,
        8
      ],
      "elementNames": [
        "어둠",
        "번개"
      ],
      "elementCodes": [
        "dark",
        "lightning"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 503,
        "atk": 913,
        "def": 503,
        "mag": 1163,
        "mr": 503,
        "spd": 913,
        "sum": 4498
      },
      "abilityId": 5,
      "abilityName": "속박",
      "baseMoveId": 108020,
      "baseMoveName": "어둠의 파동",
      "ultMoveId": 108040,
      "ultMoveName": "어둠의 권능",
      "breedingSeconds": 26100,
      "hatchingSeconds": 26100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000005,
          1008000005
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 지느러미가 붙어 있다.",
        "type": "암흑 드래곤",
        "feed": "퍼플튤립",
        "weight": "430~450kg",
        "size": "3.8~4.3m",
        "obtain": "알에 돋아난 지느러미 날개는 악마의 권위를 상징한다."
      }
    },
    {
      "id": 1008000006,
      "code": "ninjadragon",
      "name": "닌자 드래곤",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        8,
        3
      ],
      "sortedElementIds": [
        3,
        8
      ],
      "elementNames": [
        "어둠",
        "바람"
      ],
      "elementCodes": [
        "dark",
        "wind"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 587,
        "atk": 1417,
        "def": 497,
        "mag": 167,
        "mr": 837,
        "spd": 1497,
        "sum": 5002
      },
      "abilityId": 40,
      "abilityName": "급소 회피",
      "baseMoveId": 108010,
      "baseMoveName": "어둠의 발톱",
      "ultMoveId": 108030,
      "ultMoveName": "어둠의 심판",
      "breedingSeconds": 27450,
      "hatchingSeconds": 27450,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 31,
        "fixedProportion": 500,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000006,
          1008000006
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 모습을 감추려 한다.",
        "type": "닌자 드래곤",
        "feed": "퍼플튤립",
        "weight": "70~120kg",
        "size": "1.7~2.2m",
        "obtain": "그림자나 나무 뒤에 몸을 숨긴 채\\n좀처럼 제 모습을 드러내지 않는 알이다."
      }
    },
    {
      "id": 1008000007,
      "code": "kleptos",
      "name": "클렙토스",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        8,
        5
      ],
      "sortedElementIds": [
        5,
        8
      ],
      "elementNames": [
        "어둠",
        "땅"
      ],
      "elementCodes": [
        "dark",
        "earth"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 610,
        "atk": 1030,
        "def": 1030,
        "mag": 860,
        "mr": 860,
        "spd": 610,
        "sum": 5000
      },
      "abilityId": 8,
      "abilityName": "날카로운 비늘",
      "baseMoveId": 108010,
      "baseMoveName": "어둠의 발톱",
      "ultMoveId": 108030,
      "ultMoveName": "어둠의 심판",
      "breedingSeconds": 22050,
      "hatchingSeconds": 22050,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 31,
        "fixedProportion": 500,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000007,
          1008000007
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 다른 알을 주시한다.",
        "type": "알도둑 드래곤",
        "feed": "어둠의 멜론",
        "weight": "280~300kg",
        "size": "1.5~1.6m",
        "obtain": "주변을 주시하며 스스로 움직여 부화 시기를 앞당기는\\n영악한 알이다."
      }
    },
    {
      "id": 1008000008,
      "code": "skelegon",
      "name": "스켈레곤",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        8,
        1
      ],
      "sortedElementIds": [
        1,
        8
      ],
      "elementNames": [
        "어둠",
        "불"
      ],
      "elementCodes": [
        "dark",
        "fire"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 200,
        "atk": 790,
        "def": 1450,
        "mag": 790,
        "mr": 1290,
        "spd": 1,
        "sum": 4521
      },
      "abilityId": 26,
      "abilityName": "전염",
      "baseMoveId": 108020,
      "baseMoveName": "어둠의 파동",
      "ultMoveId": 108040,
      "ultMoveName": "어둠의 권능",
      "breedingSeconds": 24750,
      "hatchingSeconds": 24750,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000008,
          1008000008
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 뼈가 튀어나와 있다.",
        "type": "해골 드래곤",
        "feed": "x",
        "weight": "50~70kg",
        "size": "1.8~3.1m",
        "obtain": "알 표면에 등뼈와 뿔이 돋아나 있으며,\\n결속력이 약해 간혹 몸체에서 빠지기도 한다."
      }
    },
    {
      "id": 1008000009,
      "code": "centipededragon",
      "name": "G네",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        8,
        4
      ],
      "sortedElementIds": [
        4,
        8
      ],
      "elementNames": [
        "어둠",
        "강철"
      ],
      "elementCodes": [
        "dark",
        "steel"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 697,
        "atk": 1117,
        "def": 1037,
        "mag": 447,
        "mr": 1037,
        "spd": 667,
        "sum": 5002
      },
      "abilityId": 47,
      "abilityName": "접촉 금지",
      "baseMoveId": 108010,
      "baseMoveName": "어둠의 발톱",
      "ultMoveId": 108030,
      "ultMoveName": "어둠의 심판",
      "breedingSeconds": 29700,
      "hatchingSeconds": 29700,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 31,
        "fixedProportion": 500,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000009,
          1008000009
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 맹독이 퍼져있다.",
        "type": "지네 드래곤",
        "feed": "귀뚜라미",
        "weight": "400~440kg",
        "size": "2.9~3.6m",
        "obtain": "알 속에 치명적인 맹독이 흐르고 있으나\\n겉으로는 전혀 티가 나지 않는다."
      }
    },
    {
      "id": 1008000010,
      "code": "nox",
      "name": "녹스",
      "rarity": 3,
      "tier": 1,
      "elementIds": [
        8
      ],
      "sortedElementIds": [
        8
      ],
      "elementNames": [
        "어둠"
      ],
      "elementCodes": [
        "dark"
      ],
      "elementCount": 1,
      "stats": {
        "hp": 532,
        "atk": 752,
        "def": 502,
        "mag": 412,
        "mr": 502,
        "spd": 302,
        "sum": 3002
      },
      "abilityId": 31,
      "abilityName": "유연한 몸",
      "baseMoveId": 108010,
      "baseMoveName": "어둠의 발톱",
      "ultMoveId": 108030,
      "ultMoveName": "어둠의 심판",
      "breedingSeconds": 23400,
      "hatchingSeconds": 23400,
      "buyable": true,
      "buyItems": "6002010001;100000",
      "canBreedAsParent": true,
      "requireUserLevel": 16,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000010,
          1008000010
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 가시는 자라난다.",
        "type": "시간 드래곤",
        "feed": "어둠의 멜론",
        "weight": "280~330kg",
        "size": "3.9~4.2m",
        "obtain": "표면에 날카로운 가시들이 돋아나 있으며,\\n매우 단단하여 쉽게 떨어지지 않는다."
      }
    },
    {
      "id": 1008000011,
      "code": "witchdragon",
      "name": "윗치 드래곤",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        8,
        10
      ],
      "sortedElementIds": [
        8,
        10
      ],
      "elementNames": [
        "어둠",
        "영혼"
      ],
      "elementCodes": [
        "dark",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 613,
        "atk": 863,
        "def": 193,
        "mag": 1193,
        "mr": 693,
        "spd": 943,
        "sum": 4498
      },
      "abilityId": 11,
      "abilityName": "불길한 동행",
      "baseMoveId": 108020,
      "baseMoveName": "어둠의 파동",
      "ultMoveId": 108040,
      "ultMoveName": "어둠의 권능",
      "breedingSeconds": 26100,
      "hatchingSeconds": 26100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000011,
          1008000011
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 드래곤의 알에서 마력이 느껴진다.",
        "type": "마녀 드래곤",
        "feed": "퍼플 튤립",
        "weight": "150~180kg",
        "size": "2.0~2.5m",
        "obtain": "흰 털과 보라색 뿔이 돋아나 있으며,\\n앞에는 붉은 지팡이가 놓여 있다."
      }
    },
    {
      "id": 1008000012,
      "code": "lagtail",
      "name": "렉테일",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        8,
        4
      ],
      "sortedElementIds": [
        4,
        8
      ],
      "elementNames": [
        "어둠",
        "강철"
      ],
      "elementCodes": [
        "dark",
        "steel"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 752,
        "atk": 1082,
        "def": 752,
        "mag": 582,
        "mr": 582,
        "spd": 752,
        "sum": 4502
      },
      "abilityId": 32,
      "abilityName": "난폭한 힘",
      "baseMoveId": 108010,
      "baseMoveName": "어둠의 발톱",
      "ultMoveId": 108030,
      "ultMoveName": "어둠의 심판",
      "breedingSeconds": 24300,
      "hatchingSeconds": 24300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000012,
          1008000012
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 불안정한 붉은 빛으로 가득차있다.",
        "type": "버그 드래곤",
        "feed": "데이터",
        "weight": "10~20kg",
        "size": "1.0~2.0m",
        "obtain": "불규칙하게 깜빡이는 붉은 빛에 휩싸여 있으며\\n주변에 이상 현상을 일으킨다."
      }
    },
    {
      "id": 1008000013,
      "code": "fides",
      "name": "피데스",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        8,
        6,
        3
      ],
      "sortedElementIds": [
        3,
        6,
        8
      ],
      "elementNames": [
        "어둠",
        "번개",
        "바람"
      ],
      "elementCodes": [
        "dark",
        "lightning",
        "wind"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 593,
        "atk": 2013,
        "def": 513,
        "mag": 1433,
        "mr": 513,
        "spd": 1433,
        "sum": 6498
      },
      "abilityId": 30,
      "abilityName": "포효",
      "baseMoveId": 108010,
      "baseMoveName": "어둠의 발톱",
      "ultMoveId": 108105,
      "ultMoveName": "심연의 낙뢰",
      "breedingSeconds": 60300,
      "hatchingSeconds": 60300,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000013,
          1008000013
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 벼락을 품고 있다.",
        "type": "번개 드래곤",
        "feed": "퍼플튤립",
        "weight": "170~250kg",
        "size": "2.5~2.9m",
        "obtain": "강력한 벼락을 품고 있어 주변을 감전시킬 만큼\\n위험하고 파괴적인 에너지를 내뿜는다."
      }
    },
    {
      "id": 1008000014,
      "code": "liso",
      "name": "리소",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        8,
        7
      ],
      "sortedElementIds": [
        7,
        8
      ],
      "elementNames": [
        "어둠",
        "빛"
      ],
      "elementCodes": [
        "dark",
        "light"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 615,
        "atk": 835,
        "def": 585,
        "mag": 1165,
        "mr": 585,
        "spd": 715,
        "sum": 4500
      },
      "abilityId": 35,
      "abilityName": "피로 회복",
      "baseMoveId": 108020,
      "baseMoveName": "어둠의 파동",
      "ultMoveId": 108040,
      "ultMoveName": "어둠의 권능",
      "breedingSeconds": 26100,
      "hatchingSeconds": 26100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1008000014,
          1008000014
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 푸른 뿔로 접근을 막는다.",
        "type": "잠 드래곤",
        "feed": "퍼플튤립",
        "weight": "490~520kg",
        "size": "3.5~3.9m",
        "obtain": "접근하는 생명체를 감지하면 푸른 뿔로\\n위협적인 태세를 취하는 알이다."
      }
    },
    {
      "id": 1009000001,
      "code": "lambgon",
      "name": "램곤",
      "rarity": 3,
      "tier": 2,
      "elementIds": [
        9
      ],
      "sortedElementIds": [
        9
      ],
      "elementNames": [
        "꿈"
      ],
      "elementCodes": [
        "dream"
      ],
      "elementCount": 1,
      "stats": {
        "hp": 303,
        "atk": 1143,
        "def": 473,
        "mag": 303,
        "mr": 303,
        "spd": 973,
        "sum": 3498
      },
      "abilityId": 45,
      "abilityName": "재생",
      "baseMoveId": 109010,
      "baseMoveName": "꿈의 발톱",
      "ultMoveId": 109030,
      "ultMoveName": "꿈의 심판",
      "breedingSeconds": 12150,
      "hatchingSeconds": 12150,
      "buyable": true,
      "buyItems": "6002010001;300000",
      "canBreedAsParent": true,
      "requireUserLevel": 20,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1009000001,
          1009000001
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 부드러운 털로 뒤덮여있다.",
        "type": "꿈 드래곤",
        "feed": "파오파오 열매",
        "weight": "150~180kg",
        "size": "1.5~1.8m",
        "obtain": "머리를 베고 누울 수 있을 만큼 푹신하며,\\n품에 안으면 금세 깊은 잠에 빠져드는 알이다."
      }
    },
    {
      "id": 1009000002,
      "code": "goldie",
      "name": "골디",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        9,
        7
      ],
      "sortedElementIds": [
        7,
        9
      ],
      "elementNames": [
        "꿈",
        "빛"
      ],
      "elementCodes": [
        "dream",
        "light"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 488,
        "atk": 1198,
        "def": 538,
        "mag": 588,
        "mr": 648,
        "spd": 538,
        "sum": 3998
      },
      "abilityId": 49,
      "abilityName": "행운아",
      "baseMoveId": 109010,
      "baseMoveName": "꿈의 발톱",
      "ultMoveId": 109030,
      "ultMoveName": "꿈의 심판",
      "breedingSeconds": 29700,
      "hatchingSeconds": 29700,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1009000002,
          1009000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 골드 모양 마크가 있다.",
        "type": "금 드래곤",
        "feed": "광석",
        "weight": "500~600kg",
        "size": "4.3~5.5m",
        "obtain": "금으로 된 이 알은 매우 무거워\\n특수 장비 없이는 쉽게 들 수 없다."
      }
    },
    {
      "id": 1009000003,
      "code": "nebula",
      "name": "네뷸라",
      "rarity": 4,
      "tier": 7,
      "elementIds": [
        9,
        1,
        2
      ],
      "sortedElementIds": [
        1,
        2,
        9
      ],
      "elementNames": [
        "꿈",
        "불",
        "물"
      ],
      "elementCodes": [
        "dream",
        "fire",
        "water"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 415,
        "atk": 2035,
        "def": 865,
        "mag": 365,
        "mr": 1205,
        "spd": 1115,
        "sum": 6000
      },
      "abilityId": 10,
      "abilityName": "천리안",
      "baseMoveId": 109010,
      "baseMoveName": "꿈의 발톱",
      "ultMoveId": 109103,
      "ultMoveName": "황홀한 빛",
      "breedingSeconds": 56250,
      "hatchingSeconds": 56250,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 19,
        "fixedProportion": 150,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1009000003,
          1009000003
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 별의 기운을 담고 있다.",
        "type": "성운 드래곤",
        "feed": "스타후르츠",
        "weight": "180~210kg",
        "size": "2~2.3m",
        "obtain": "별의 기운을 담은 이 알은 밤이 되면\\n온 우주를 비추며 영롱하게 반짝인다."
      }
    },
    {
      "id": 1009000004,
      "code": "henes",
      "name": "헤네스",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        9,
        6
      ],
      "sortedElementIds": [
        6,
        9
      ],
      "elementNames": [
        "꿈",
        "번개"
      ],
      "elementCodes": [
        "dream",
        "lightning"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 317,
        "atk": 1237,
        "def": 807,
        "mag": 67,
        "mr": 1317,
        "spd": 757,
        "sum": 4502
      },
      "abilityId": 13,
      "abilityName": "차력",
      "baseMoveId": 109010,
      "baseMoveName": "꿈의 발톱",
      "ultMoveId": 109030,
      "ultMoveName": "꿈의 심판",
      "breedingSeconds": 24750,
      "hatchingSeconds": 24750,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1009000004,
          1009000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 가면을 쓰고 있다.",
        "type": "사도 드래곤",
        "feed": "신들린 호박",
        "weight": "180~230kg",
        "size": "1.8~2.5m",
        "obtain": "무거운 가면을 쓰고 있으며,\\n그 뒤에 돋아난 날개가 생동감 있게 움직인다."
      }
    },
    {
      "id": 1009000005,
      "code": "pierrotdragon",
      "name": "삐에로 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        9,
        8
      ],
      "sortedElementIds": [
        8,
        9
      ],
      "elementNames": [
        "꿈",
        "어둠"
      ],
      "elementCodes": [
        "dream",
        "dark"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 2710,
        "atk": 90,
        "def": 510,
        "mag": 90,
        "mr": 510,
        "spd": 90,
        "sum": 4000
      },
      "abilityId": 33,
      "abilityName": "인내",
      "baseMoveId": 109010,
      "baseMoveName": "꿈의 발톱",
      "ultMoveId": 109030,
      "ultMoveName": "꿈의 심판",
      "breedingSeconds": 27450,
      "hatchingSeconds": 27450,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1009000005,
          1009000005
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 웃음소리가 들려온다.",
        "type": "광대 드래곤",
        "feed": "무지개 꽃",
        "weight": "90~120kg",
        "size": "1.6~2m",
        "obtain": "알에서 새어 나오는 기묘한 웃음소리는 때로\\n섬뜩한 전율을 느끼게 한다."
      }
    },
    {
      "id": 1009000006,
      "code": "fairydragon",
      "name": "페어리 드래곤",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        9,
        10
      ],
      "sortedElementIds": [
        9,
        10
      ],
      "elementNames": [
        "꿈",
        "영혼"
      ],
      "elementCodes": [
        "dream",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 525,
        "atk": 695,
        "def": 615,
        "mag": 1025,
        "mr": 615,
        "spd": 1025,
        "sum": 4500
      },
      "abilityId": 37,
      "abilityName": "정화",
      "baseMoveId": 109020,
      "baseMoveName": "꿈의 파동",
      "ultMoveId": 109040,
      "ultMoveName": "꿈의 권능",
      "breedingSeconds": 32850,
      "hatchingSeconds": 32850,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1009000006,
          1009000006
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 더듬이는 상황을 살핀다.",
        "type": "요정 드래곤",
        "feed": "스타후르츠",
        "weight": "40~60kg",
        "size": "1.5~1.7m",
        "obtain": "꽃으로 착각할 만큼 화려하며,\\n빛을 내는 더듬이가 돋아나 있다."
      }
    },
    {
      "id": 1009000007,
      "code": "seere",
      "name": "세에레",
      "rarity": 4,
      "tier": 7,
      "elementIds": [
        9,
        5,
        3
      ],
      "sortedElementIds": [
        3,
        5,
        9
      ],
      "elementNames": [
        "꿈",
        "땅",
        "바람"
      ],
      "elementCodes": [
        "dream",
        "earth",
        "wind"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 793,
        "atk": 623,
        "def": 1703,
        "mag": 1543,
        "mr": 793,
        "spd": 543,
        "sum": 5998
      },
      "abilityId": 22,
      "abilityName": "불면증",
      "baseMoveId": 109020,
      "baseMoveName": "꿈의 파동",
      "ultMoveId": 109104,
      "ultMoveName": "운명의 전환",
      "breedingSeconds": 53550,
      "hatchingSeconds": 53550,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 19,
        "fixedProportion": 150,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1009000007,
          1009000007
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 후드는 벗기지 않는 것이 좋다.",
        "type": "꿈 드래곤",
        "feed": "스타후르츠",
        "weight": "50~80kg",
        "size": "1.2~1.8m",
        "obtain": "붉은 후드로 감싸인 알 양옆으로 신비로운 영혼불이\\n끊임없이 타오르고 있다."
      }
    },
    {
      "id": 1009000008,
      "code": "cupid",
      "name": "큐피트",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        9,
        3
      ],
      "sortedElementIds": [
        3,
        9
      ],
      "elementNames": [
        "꿈",
        "바람"
      ],
      "elementCodes": [
        "dream",
        "wind"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1405,
        "atk": 395,
        "def": 895,
        "mag": 1255,
        "mr": 1055,
        "spd": 1,
        "sum": 5006
      },
      "abilityId": 35,
      "abilityName": "피로 회복",
      "baseMoveId": 109020,
      "baseMoveName": "꿈의 파동",
      "ultMoveId": 109040,
      "ultMoveName": "꿈의 권능",
      "breedingSeconds": 26550,
      "hatchingSeconds": 26550,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 31,
        "fixedProportion": 500,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1009000008,
          1009000008
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 하트 무늬를 가지고 있다.",
        "type": "사랑 드래곤",
        "feed": "스타후르츠",
        "weight": "55~70kg",
        "size": "1.5~1.8m",
        "obtain": "주변으로 사랑의 기운을 발산하며,\\n닿는 식물들을 하트 모양으로 변화시킨다."
      }
    },
    {
      "id": 1009000009,
      "code": "alien",
      "name": "에일리언 드래곤",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        9,
        6
      ],
      "sortedElementIds": [
        6,
        9
      ],
      "elementNames": [
        "꿈",
        "번개"
      ],
      "elementCodes": [
        "dream",
        "lightning"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 527,
        "atk": 1477,
        "def": 477,
        "mag": 477,
        "mr": 1317,
        "spd": 727,
        "sum": 5002
      },
      "abilityId": 20,
      "abilityName": "공중부양",
      "baseMoveId": 109010,
      "baseMoveName": "꿈의 발톱",
      "ultMoveId": 109030,
      "ultMoveName": "꿈의 심판",
      "breedingSeconds": 26100,
      "hatchingSeconds": 26100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1009000009,
          1009000009
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 고리는 매우 섬세하다.",
        "type": "우주 드래곤",
        "feed": "스타후르츠",
        "weight": "60~80kg",
        "size": "1.6~1.9m",
        "obtain": "보라색 링에 둘러싸인 이 알은\\n기이한 분위기를 자아낸다."
      }
    },
    {
      "id": 1009000010,
      "code": "crevasse",
      "name": "크레바스",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        9,
        3,
        10
      ],
      "sortedElementIds": [
        3,
        9,
        10
      ],
      "elementNames": [
        "꿈",
        "바람",
        "영혼"
      ],
      "elementCodes": [
        "dream",
        "wind",
        "soul"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 497,
        "atk": 787,
        "def": 447,
        "mag": 2117,
        "mr": 1617,
        "spd": 1037,
        "sum": 6502
      },
      "abilityId": 55,
      "abilityName": "악몽",
      "baseMoveId": 109020,
      "baseMoveName": "꿈의 파동",
      "ultMoveId": 109105,
      "ultMoveName": "검은 안개",
      "breedingSeconds": 64800,
      "hatchingSeconds": 64800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1009000010,
          1009000010
        ]
      },
      "drop": "raid",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 꿈의 안개를 모은다.",
        "type": "재앙 드래곤",
        "feed": "스타후르츠",
        "weight": "650~680kg",
        "size": "9.5~9.8m",
        "obtain": "꿈의 안개를 끌어모으는 성질이 있으며,\\n모인 안개는 주변에 깊은 잠을 불러온다."
      }
    },
    {
      "id": 1010000001,
      "code": "goblindragon",
      "name": "깨비곤",
      "rarity": 3,
      "tier": 2,
      "elementIds": [
        10
      ],
      "sortedElementIds": [
        10
      ],
      "elementNames": [
        "영혼"
      ],
      "elementCodes": [
        "soul"
      ],
      "elementCount": 1,
      "stats": {
        "hp": 857,
        "atk": 437,
        "def": 487,
        "mag": 687,
        "mr": 767,
        "spd": 267,
        "sum": 3502
      },
      "abilityId": 18,
      "abilityName": "동화",
      "baseMoveId": 110020,
      "baseMoveName": "영혼의 파동",
      "ultMoveId": 110040,
      "ultMoveName": "영혼의 권능",
      "breedingSeconds": 12150,
      "hatchingSeconds": 12150,
      "buyable": true,
      "buyItems": "6002010001;500000",
      "canBreedAsParent": true,
      "requireUserLevel": 24,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1010000001,
          1010000001
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 잡귀를 느낄 수 있다.",
        "type": "퇴마 드래곤",
        "feed": "멜론",
        "weight": "70~95kg",
        "size": "1.6~2.0m",
        "obtain": "잡귀와 마물의 기운을 민감하게 감지하며,\\n해로운 존재가 나타나면 경고를 보낸다."
      }
    },
    {
      "id": 1010000002,
      "code": "slimedragon",
      "name": "슬라임 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        10,
        2
      ],
      "sortedElementIds": [
        2,
        10
      ],
      "elementNames": [
        "영혼",
        "물"
      ],
      "elementCodes": [
        "soul",
        "water"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 770,
        "atk": 700,
        "def": 690,
        "mag": 190,
        "mr": 850,
        "spd": 800,
        "sum": 4000
      },
      "abilityId": 3,
      "abilityName": "늪",
      "baseMoveId": 110010,
      "baseMoveName": "영혼의 발톱",
      "ultMoveId": 110030,
      "ultMoveName": "영혼의 심판",
      "breedingSeconds": 24750,
      "hatchingSeconds": 24750,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1010000002,
          1010000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 액체와 비슷하다.",
        "type": "액체 드래곤",
        "feed": "신들린 호박",
        "weight": "110~160kg",
        "size": "1.6~2.2m",
        "obtain": "액체와 유사한 형태를 띠고 있으며,\\n만지면 기분 좋게 꿀렁거리는 촉감을 가졌다."
      }
    },
    {
      "id": 1010000003,
      "code": "mistdragon",
      "name": "미스트 드래곤",
      "rarity": 4,
      "tier": 3,
      "elementIds": [
        10,
        5
      ],
      "sortedElementIds": [
        5,
        10
      ],
      "elementNames": [
        "영혼",
        "땅"
      ],
      "elementCodes": [
        "soul",
        "earth"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 742,
        "atk": 542,
        "def": 492,
        "mag": 542,
        "mr": 1242,
        "spd": 442,
        "sum": 4002
      },
      "abilityId": 14,
      "abilityName": "냉기저항",
      "baseMoveId": 110010,
      "baseMoveName": "영혼의 발톱",
      "ultMoveId": 110030,
      "ultMoveName": "영혼의 심판",
      "breedingSeconds": 25200,
      "hatchingSeconds": 25200,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 43,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1010000003,
          1010000003
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 드래곤의 알은 으스스하다.",
        "type": "유령 드래곤",
        "feed": "영혼",
        "weight": "10~25kg",
        "size": "2.5~3.0m",
        "obtain": "으스스한 기운이 감도는 알에는\\n분홍빛 십자가 무늬가 선명히 새겨져 있다."
      }
    },
    {
      "id": 1010000004,
      "code": "mummydragon",
      "name": "미이라곤",
      "rarity": 4,
      "tier": 5,
      "elementIds": [
        10,
        8
      ],
      "sortedElementIds": [
        8,
        10
      ],
      "elementNames": [
        "영혼",
        "어둠"
      ],
      "elementCodes": [
        "soul",
        "dark"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1222,
        "atk": 1052,
        "def": 622,
        "mag": 682,
        "mr": 522,
        "spd": 902,
        "sum": 5002
      },
      "abilityId": 45,
      "abilityName": "재생",
      "baseMoveId": 110010,
      "baseMoveName": "영혼의 발톱",
      "ultMoveId": 110030,
      "ultMoveName": "영혼의 심판",
      "breedingSeconds": 27450,
      "hatchingSeconds": 27450,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1010000004,
          1010000004
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 붕대가 감겨있다.",
        "type": "붕대 드래곤",
        "feed": "퍼플튤립",
        "weight": "130~160kg",
        "size": "2.5~3.0m",
        "obtain": "붕대로 칭칭 감겨져 있는 알이다."
      }
    },
    {
      "id": 1010000005,
      "code": "gripo",
      "name": "그리포",
      "rarity": 4,
      "tier": 4,
      "elementIds": [
        10,
        1
      ],
      "sortedElementIds": [
        1,
        10
      ],
      "elementNames": [
        "영혼",
        "불"
      ],
      "elementCodes": [
        "soul",
        "fire"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 403,
        "atk": 823,
        "def": 233,
        "mag": 983,
        "mr": 823,
        "spd": 1233,
        "sum": 4498
      },
      "abilityId": 20,
      "abilityName": "공중부양",
      "baseMoveId": 110020,
      "baseMoveName": "영혼의 파동",
      "ultMoveId": 110040,
      "ultMoveName": "영혼의 권능",
      "breedingSeconds": 30600,
      "hatchingSeconds": 30600,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 37,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1010000005,
          1010000005
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 무엇이든 움켜쥐려고 한다.",
        "type": "습격 드래곤",
        "feed": "육포",
        "weight": "40~50kg",
        "size": "1.2~1.5m",
        "obtain": "알 위에 피어오르는 푸른 불꽃은\\n다른 생명체를 유혹해 가까이 끌어들인다."
      }
    },
    {
      "id": 1010000006,
      "code": "dreaden",
      "name": "드래든",
      "rarity": 4,
      "tier": 7,
      "elementIds": [
        10,
        8,
        3
      ],
      "sortedElementIds": [
        3,
        8,
        10
      ],
      "elementNames": [
        "영혼",
        "어둠",
        "바람"
      ],
      "elementCodes": [
        "soul",
        "dark",
        "wind"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 1265,
        "atk": 855,
        "def": 905,
        "mag": 1105,
        "mr": 1185,
        "spd": 685,
        "sum": 6000
      },
      "abilityId": 40,
      "abilityName": "급소 회피",
      "baseMoveId": 110020,
      "baseMoveName": "영혼의 파동",
      "ultMoveId": 110103,
      "ultMoveName": "강령술",
      "breedingSeconds": 59850,
      "hatchingSeconds": 59850,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 19,
        "fixedProportion": 150,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1010000006,
          1010000006
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 죽은 생명의 영혼을 불러들인다.",
        "type": "어둠 드래곤",
        "feed": "어둠의 멜론",
        "weight": "60~70kg",
        "size": "1.5~1.8m",
        "obtain": "죽은 생명의 영혼을 불러들이는 이 알에는\\n기묘한 분위기를 자아낸다."
      }
    },
    {
      "id": 1010000007,
      "code": "lucio",
      "name": "루시오",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        10,
        2,
        8
      ],
      "sortedElementIds": [
        2,
        8,
        10
      ],
      "elementNames": [
        "영혼",
        "물",
        "어둠"
      ],
      "elementCodes": [
        "soul",
        "water",
        "dark"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 737,
        "atk": 1237,
        "def": 657,
        "mag": 1237,
        "mr": 1067,
        "spd": 1567,
        "sum": 6502
      },
      "abilityId": 22,
      "abilityName": "불면증",
      "baseMoveId": 110010,
      "baseMoveName": "영혼의 발톱",
      "ultMoveId": 110106,
      "ultMoveName": "혼령의 파도",
      "breedingSeconds": 64800,
      "hatchingSeconds": 64800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1010000007,
          1010000007
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 환각을 선사한다.",
        "type": "환각 드래곤",
        "feed": "퍼플튤립",
        "weight": "110~160kg",
        "size": "2.6~3.3m",
        "obtain": "기이한 소리를 내며 주변을 기묘한 환각으로\\n빠트리는 알이다."
      }
    },
    {
      "id": 1010000008,
      "code": "centura",
      "name": "센투라",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        10,
        3,
        9
      ],
      "sortedElementIds": [
        3,
        9,
        10
      ],
      "elementNames": [
        "영혼",
        "바람",
        "꿈"
      ],
      "elementCodes": [
        "soul",
        "wind",
        "dream"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 1048,
        "atk": 1268,
        "def": 918,
        "mag": 1268,
        "mr": 918,
        "spd": 1078,
        "sum": 6498
      },
      "abilityId": 50,
      "abilityName": "강인한 의지",
      "baseMoveId": 110010,
      "baseMoveName": "영혼의 발톱",
      "ultMoveId": 110107,
      "ultMoveName": "영혼 파괴",
      "breedingSeconds": 64800,
      "hatchingSeconds": 64800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": true,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": true,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1010000008,
          1010000008
        ]
      },
      "drop": "sell",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 푸른 화염에 갇혀있다.",
        "type": "화염 드래곤",
        "feed": "스타후르츠",
        "weight": "400~430kg",
        "size": "4.5~5.1m",
        "obtain": "알은 라테아의 푸른 화염이 두르고 있으며,\\n알의 눈은 부화전까지 주변을 매시간 감시한다."
      }
    },
    {
      "id": 1011000001,
      "code": "angeljr",
      "name": "엔젤주니어",
      "rarity": 5,
      "tier": 8,
      "elementIds": [
        11,
        7,
        6
      ],
      "sortedElementIds": [
        6,
        7,
        11
      ],
      "elementNames": [
        "여명",
        "빛",
        "번개"
      ],
      "elementCodes": [
        "dawn",
        "light",
        "lightning"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 1292,
        "atk": 1792,
        "def": 1042,
        "mag": 792,
        "mr": 792,
        "spd": 542,
        "sum": 6252
      },
      "abilityId": 57,
      "abilityName": "숨결의 동화",
      "baseMoveId": 111010,
      "baseMoveName": "여명의 발톱",
      "ultMoveId": 111103,
      "ultMoveName": "수호의 여명",
      "breedingSeconds": 64800,
      "hatchingSeconds": 64800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 13,
        "fixedProportion": 75,
        "requireParentElementRule": false,
        "parentElementCount": 5,
        "parentElementRequirementIds": [
          3,
          6,
          7
        ],
        "parentElementRequirementNames": [
          "바람",
          "번개",
          "빛"
        ],
        "parentDidRequirements": [],
        "recommendParents": [
          1011000001,
          1011000001
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 작은 날개를 가지고 있다.",
        "type": "천사 드래곤",
        "feed": "멜론",
        "weight": "120~160kg",
        "size": "2.5~2.9m",
        "obtain": "뿔과 날개는 기분에 따라 움직이며,\\n표면은 부드러운 털로 덮여 있다."
      }
    },
    {
      "id": 1011000002,
      "code": "toddletomtom",
      "name": "터들톰톰",
      "rarity": 4,
      "tier": 6,
      "elementIds": [
        11,
        5
      ],
      "sortedElementIds": [
        5,
        11
      ],
      "elementNames": [
        "여명",
        "땅"
      ],
      "elementCodes": [
        "dawn",
        "earth"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1130,
        "atk": 1210,
        "def": 610,
        "mag": 1210,
        "mr": 660,
        "spd": 680,
        "sum": 5500
      },
      "abilityId": 37,
      "abilityName": "정화",
      "baseMoveId": 111010,
      "baseMoveName": "여명의 발톱",
      "ultMoveId": 111030,
      "ultMoveName": "여명의 심판",
      "breedingSeconds": 26100,
      "hatchingSeconds": 26100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 10,
      "breeding": {
        "portion": 25,
        "fixedProportion": 300,
        "requireParentElementRule": false,
        "parentElementCount": 4,
        "parentElementRequirementIds": [
          2,
          5
        ],
        "parentElementRequirementNames": [
          "물",
          "땅"
        ],
        "parentDidRequirements": [],
        "recommendParents": [
          1011000002,
          1011000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 별을 반짝인다.",
        "type": "빛 드래곤",
        "feed": "멜론",
        "weight": "60~70kg",
        "size": "1.8~2.1m",
        "obtain": "수많은 별이 알 위에서 아름답게 반짝이며,\\n마주하면 별들이 떨어져 주변을 맴돈다."
      }
    },
    {
      "id": 1011000003,
      "code": "florea",
      "name": "플로레",
      "rarity": 5,
      "tier": 8,
      "elementIds": [
        11,
        9,
        8
      ],
      "sortedElementIds": [
        8,
        9,
        11
      ],
      "elementNames": [
        "여명",
        "꿈",
        "어둠"
      ],
      "elementCodes": [
        "dawn",
        "dream",
        "dark"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 948,
        "atk": 358,
        "def": 1108,
        "mag": 1528,
        "mr": 1448,
        "spd": 858,
        "sum": 6248
      },
      "abilityId": 33,
      "abilityName": "인내",
      "baseMoveId": 111020,
      "baseMoveName": "여명의 파동",
      "ultMoveId": 111106,
      "ultMoveName": "단절의 소용돌이",
      "breedingSeconds": 26100,
      "hatchingSeconds": 26100,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": false,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1011000003,
          1011000003
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 운명을 본다.",
        "type": "운명 드래곤",
        "feed": "무지개 꽃",
        "weight": "190~220kg",
        "size": "2.7~3.2m",
        "obtain": "부화 전까지는 미동도 없이 고요를 유지하며,\\n운명을 읽어낸다."
      }
    },
    {
      "id": 1011000004,
      "code": "whitedragon",
      "name": "백룡",
      "rarity": 4,
      "tier": 7,
      "elementIds": [
        11,
        7
      ],
      "sortedElementIds": [
        7,
        11
      ],
      "elementNames": [
        "여명",
        "빛"
      ],
      "elementCodes": [
        "dawn",
        "light"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1155,
        "atk": 1015,
        "def": 1105,
        "mag": 905,
        "mr": 905,
        "spd": 915,
        "sum": 6000
      },
      "abilityId": 31,
      "abilityName": "유연한 몸",
      "baseMoveId": 111010,
      "baseMoveName": "여명의 발톱",
      "ultMoveId": 111030,
      "ultMoveName": "여명의 심판",
      "breedingSeconds": 7200,
      "hatchingSeconds": 7200,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 19,
        "fixedProportion": 150,
        "requireParentElementRule": false,
        "parentElementCount": 4,
        "parentElementRequirementIds": [
          2,
          7
        ],
        "parentElementRequirementNames": [
          "물",
          "빛"
        ],
        "parentDidRequirements": [],
        "recommendParents": [
          1011000004,
          1011000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 주변은 환한 빛이 생긴다.",
        "type": "희망 드래곤",
        "feed": "멜론",
        "weight": "250~310kg",
        "size": "3.5~3.9m",
        "obtain": "환한 낮에만 발견되며,\\n어두운 밤에는 스스로 모습을 감추는 알이다."
      }
    },
    {
      "id": 1012000001,
      "code": "aila",
      "name": "에이라",
      "rarity": 4,
      "tier": 8,
      "elementIds": [
        12,
        9,
        3
      ],
      "sortedElementIds": [
        3,
        9,
        12
      ],
      "elementNames": [
        "황혼",
        "꿈",
        "바람"
      ],
      "elementCodes": [
        "dusk",
        "dream",
        "wind"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 667,
        "atk": 667,
        "def": 667,
        "mag": 1417,
        "mr": 1417,
        "spd": 1417,
        "sum": 6252
      },
      "abilityId": 5,
      "abilityName": "속박",
      "baseMoveId": 112020,
      "baseMoveName": "황혼의 파동",
      "ultMoveId": 112103,
      "ultMoveName": "찬란한 구체",
      "breedingSeconds": 64800,
      "hatchingSeconds": 64800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 13,
        "fixedProportion": 75,
        "requireParentElementRule": false,
        "parentElementCount": 5,
        "parentElementRequirementIds": [
          8,
          9,
          10
        ],
        "parentElementRequirementNames": [
          "어둠",
          "꿈",
          "영혼"
        ],
        "parentDidRequirements": [],
        "recommendParents": [
          1012000001,
          1012000001
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 별빛을 모은다.",
        "type": "우주 드래곤",
        "feed": "스타후르츠",
        "weight": "120~150kg",
        "size": "2.5~3.2m",
        "obtain": "밤하늘의 별빛을 끌어모으는 알로,\\n빛이 찬란해질수록 날개 개수가 늘어난다."
      }
    },
    {
      "id": 1012000002,
      "code": "characen",
      "name": "카라선",
      "rarity": 4,
      "tier": 6,
      "elementIds": [
        12,
        9
      ],
      "sortedElementIds": [
        9,
        12
      ],
      "elementNames": [
        "황혼",
        "꿈"
      ],
      "elementCodes": [
        "dusk",
        "dream"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 472,
        "atk": 392,
        "def": 972,
        "mag": 1892,
        "mr": 972,
        "spd": 802,
        "sum": 5502
      },
      "abilityId": 42,
      "abilityName": "치유의 비",
      "baseMoveId": 112020,
      "baseMoveName": "황혼의 파동",
      "ultMoveId": 112040,
      "ultMoveName": "황혼의 권능",
      "breedingSeconds": 29700,
      "hatchingSeconds": 29700,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 20,
      "breeding": {
        "portion": 25,
        "fixedProportion": 300,
        "requireParentElementRule": false,
        "parentElementCount": 4,
        "parentElementRequirementIds": [
          1,
          9
        ],
        "parentElementRequirementNames": [
          "불",
          "꿈"
        ],
        "parentDidRequirements": [],
        "recommendParents": [
          1012000002,
          1012000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알에는 열쇠 구멍이 있다.",
        "type": "유랑 드래곤",
        "feed": "스타후르츠",
        "weight": "80~98kg",
        "size": "1.8~2.3m",
        "obtain": "보석이 박힌 거대한 자물쇠 형상이며,\\n뿔 사이에는 열쇠가 그려진 투명한 판이 달려 있다."
      }
    },
    {
      "id": 1012000003,
      "code": "non",
      "name": "논",
      "rarity": 5,
      "tier": 9,
      "elementIds": [
        12,
        10,
        8
      ],
      "sortedElementIds": [
        8,
        10,
        12
      ],
      "elementNames": [
        "황혼",
        "영혼",
        "어둠"
      ],
      "elementCodes": [
        "dusk",
        "soul",
        "dark"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 375,
        "atk": 1295,
        "def": 1875,
        "mag": 705,
        "mr": 1875,
        "spd": 375,
        "sum": 6500
      },
      "abilityId": 22,
      "abilityName": "불면증",
      "baseMoveId": 112010,
      "baseMoveName": "황혼의 발톱",
      "ultMoveId": 112106,
      "ultMoveName": "황혼의 균열",
      "breedingSeconds": 61200,
      "hatchingSeconds": 61200,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": false,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1012000003,
          1012000003
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 공허의 심연에서 발견된다.",
        "type": "어둠 드래곤",
        "feed": "스타후루츠",
        "weight": "200~280kg",
        "size": "2.9~3.7m",
        "obtain": "공허의 심연 속에서 탄생하며, 은하의 기운을 품고 있다."
      }
    },
    {
      "id": 1012000004,
      "code": "blackdragon",
      "name": "흑룡",
      "rarity": 4,
      "tier": 7,
      "elementIds": [
        12,
        8
      ],
      "sortedElementIds": [
        8,
        12
      ],
      "elementNames": [
        "황혼",
        "어둠"
      ],
      "elementCodes": [
        "dusk",
        "dark"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 912,
        "atk": 1432,
        "def": 762,
        "mag": 1232,
        "mr": 732,
        "spd": 932,
        "sum": 6002
      },
      "abilityId": 30,
      "abilityName": "포효",
      "baseMoveId": 112010,
      "baseMoveName": "황혼의 발톱",
      "ultMoveId": 112030,
      "ultMoveName": "황혼의 심판",
      "breedingSeconds": 11700,
      "hatchingSeconds": 11700,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 19,
        "fixedProportion": 150,
        "requireParentElementRule": false,
        "parentElementCount": 4,
        "parentElementRequirementIds": [
          1,
          8
        ],
        "parentElementRequirementNames": [
          "불",
          "어둠"
        ],
        "parentDidRequirements": [],
        "recommendParents": [
          1012000004,
          1012000004
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 주변은 어두운 안개가 생긴다.",
        "type": "암흑 드래곤",
        "feed": "어둠의 멜론",
        "weight": "200~250kg",
        "size": "3.1~3.7m",
        "obtain": "어두운 밤에만 모습을 드러내며,\\n늘 짙은 안개로 뒤덮여 있다."
      }
    },
    {
      "id": 1013000001,
      "code": "goddragon",
      "name": "고대신룡",
      "rarity": 5,
      "tier": 10,
      "elementIds": [
        13,
        7,
        3
      ],
      "sortedElementIds": [
        3,
        7,
        13
      ],
      "elementNames": [
        "신성",
        "빛",
        "바람"
      ],
      "elementCodes": [
        "divine",
        "light",
        "wind"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 947,
        "atk": 1777,
        "def": 1277,
        "mag": 1277,
        "mr": 947,
        "spd": 777,
        "sum": 7002
      },
      "abilityId": 34,
      "abilityName": "무결",
      "baseMoveId": 113010,
      "baseMoveName": "신성의 발톱",
      "ultMoveId": 113103,
      "ultMoveName": "광명의 파동",
      "breedingSeconds": 86400,
      "hatchingSeconds": 86400,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 14,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": false,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1013000001,
          1013000001
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알에는 노란 점들이 있다.",
        "type": "빛 드래곤",
        "feed": "멜론",
        "weight": "250~330kg",
        "size": "3.3~3.5m",
        "obtain": "따스한 온기와 황홀한 빛을 내뿜으며,\\n밤이면 달보다 밝게 빛나 길을 인도한다."
      }
    },
    {
      "id": 1013000002,
      "code": "granos",
      "name": "그라노스",
      "rarity": 4,
      "tier": 6,
      "elementIds": [
        13,
        4
      ],
      "sortedElementIds": [
        4,
        13
      ],
      "elementNames": [
        "신성",
        "강철"
      ],
      "elementCodes": [
        "divine",
        "steel"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 540,
        "atk": 540,
        "def": 460,
        "mag": 1290,
        "mr": 1040,
        "spd": 1630,
        "sum": 5500
      },
      "abilityId": 49,
      "abilityName": "행운아",
      "baseMoveId": 113020,
      "baseMoveName": "신성의 파동",
      "ultMoveId": 113040,
      "ultMoveName": "신성의 권능",
      "breedingSeconds": 32850,
      "hatchingSeconds": 32850,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 8,
      "breeding": {
        "portion": 25,
        "fixedProportion": 300,
        "requireParentElementRule": false,
        "parentElementCount": 4,
        "parentElementRequirementIds": [
          4,
          7
        ],
        "parentElementRequirementNames": [
          "강철",
          "빛"
        ],
        "parentDidRequirements": [],
        "recommendParents": [
          1013000002,
          1013000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 신성한 기운이 느껴진다.",
        "type": "신성 드래곤",
        "feed": "메뚜기",
        "weight": "110~140kg",
        "size": "3.0~3.3m",
        "obtain": "푸른 보석과 황금 고리가 신성한 기운을 자아낸다."
      }
    },
    {
      "id": 1014000001,
      "code": "darknix",
      "name": "다크닉스",
      "rarity": 5,
      "tier": 10,
      "elementIds": [
        14,
        8,
        6
      ],
      "sortedElementIds": [
        6,
        8,
        14
      ],
      "elementNames": [
        "혼돈",
        "어둠",
        "번개"
      ],
      "elementCodes": [
        "chaos",
        "dark",
        "lightning"
      ],
      "elementCount": 3,
      "stats": {
        "hp": 947,
        "atk": 1277,
        "def": 947,
        "mag": 1777,
        "mr": 1277,
        "spd": 777,
        "sum": 7002
      },
      "abilityId": 34,
      "abilityName": "무결",
      "baseMoveId": 114020,
      "baseMoveName": "혼돈의 파동",
      "ultMoveId": 114103,
      "ultMoveName": "파멸의 고동",
      "breedingSeconds": 84600,
      "hatchingSeconds": 84600,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 8,
      "requireUserLevelByElement": 16,
      "breeding": {
        "portion": 0,
        "fixedProportion": 0,
        "requireParentElementRule": false,
        "parentElementCount": 0,
        "parentElementRequirementIds": [],
        "parentElementRequirementNames": [],
        "parentDidRequirements": [],
        "recommendParents": [
          1014000001,
          1014000001
        ]
      },
      "drop": "gacha_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알의 붉은 힘을 조심해야 한다.",
        "type": "어둠 드래곤",
        "feed": "어둠의 멜론",
        "weight": "300~350kg",
        "size": "2.9~3.1m",
        "obtain": "칠흑 같은 알을 만지는 순간 끝없는 절망에\\n사로잡히게 된다."
      }
    },
    {
      "id": 1014000002,
      "code": "shadow",
      "name": "섀도우 드래곤",
      "rarity": 4,
      "tier": 6,
      "elementIds": [
        14,
        10
      ],
      "sortedElementIds": [
        10,
        14
      ],
      "elementNames": [
        "혼돈",
        "영혼"
      ],
      "elementCodes": [
        "chaos",
        "soul"
      ],
      "elementCount": 2,
      "stats": {
        "hp": 1152,
        "atk": 1402,
        "def": 902,
        "mag": 742,
        "mr": 902,
        "spd": 402,
        "sum": 5502
      },
      "abilityId": 32,
      "abilityName": "난폭한 힘",
      "baseMoveId": 114010,
      "baseMoveName": "혼돈의 발톱",
      "ultMoveId": 114030,
      "ultMoveName": "혼돈의 심판",
      "breedingSeconds": 28800,
      "hatchingSeconds": 28800,
      "buyable": false,
      "buyItems": "",
      "canBreedAsParent": false,
      "requireUserLevel": 7,
      "requireUserLevelByElement": 24,
      "breeding": {
        "portion": 25,
        "fixedProportion": 300,
        "requireParentElementRule": false,
        "parentElementCount": 4,
        "parentElementRequirementIds": [
          8,
          10
        ],
        "parentElementRequirementNames": [
          "어둠",
          "영혼"
        ],
        "parentDidRequirements": [],
        "recommendParents": [
          1014000002,
          1014000002
        ]
      },
      "drop": "breed_normal",
      "encyclopediaNo": 0,
      "ecology": {
        "egg": "이 알은 어두컴컴한 기운이 서려 있다.",
        "type": "그림자 드래곤",
        "feed": "퍼플튤립",
        "weight": "30~60kg",
        "size": "1.8~3m",
        "obtain": "그림자를 빨아들여 몸을 숨기기 때문에\\n눈에 잘 띄지 않는다."
      }
    }
  ]
}
